{
  "nav": {
    "dashboard": "Panel",
    "chats": "Chats",
    "archive": "Archivo",
    "settings": "Ajustes",
    "studioData": "Datos del estudio",
    "propertyData": "Datos de la Propiedad",
    "expandMenu": "Expandir menú",
    "collapseMenu": "Replegar menú",
    "goToDashboard": "Ir al escritorio",
    "logOut": "Cerrar sesión"
  },
  "layout": {
    "lastUpdatedJustNow": "Recién actualizado",
    "lastUpdatedOneMin": "Última actualización: hace 1 minuto",
    "lastUpdatedMins": "Última actualización: {{count}} min",
    "wsOffline": "Conexión perdida. Actualiza o espera a reconectar.",
    "refresh": "Actualizar",
    "refreshing": "Actualizando..."
  },
  "settings": {
    "title": "Ajustes",
    "subtitle": "Gestiona la cuenta, el equipo y los canales.",
    "tabAccount": "Cuenta",
    "tabTeam": "Gestión de equipos",
    "tabChannels": "Canales",
    "tabAi": "Comportamiento de IA",
    "logOut": "Cerrar sesión",
    "noPermissionToast": "No tiene permiso para ver este usuario.",
    "connections": {
      "email": {
        "channelLabel": "Correo electrónico",
        "appliesToAllStudios": "Todos los estudios",
        "addressLabel": "Buzón",
        "defaultStudioLabel": "Estudio predeterminado para hilos nuevos",
        "statusConnected": "Conectado",
        "statusReconnectRequired": "Reconexión necesaria",
        "statusDisconnected": "No conectado",
        "statusError": "Error",
        "statusSkipped": "Omitido",
        "connect": "Conectar",
        "reconnect": "Reconectar",
        "disconnect": "Desconectar",
        "reconnectBanner": "Su conexión de correo expiró. Reconecte para enviar y recibir mensajes.",
        "reconnectBannerCta": "Reconectar correo",
        "disconnectTitle": "¿Desconectar correo?",
        "disconnectBody": "Esto revoca el acceso al buzón compartido. Los hilos anteriores siguen legibles; el envío queda deshabilitado hasta volver a conectar.",
        "toastDisconnected": "Correo desconectado.",
        "toastDisconnectFailed": "No se pudo desconectar el correo."
      }
    }
  },
  "account": {
    "displayLanguageTitle": "Idioma de la pantalla",
    "displayLanguageHint": "Inglés, alemán, francés, italiano y español se aplican en toda la aplicación, incluido el inicio de sesión, el registro y la incorporación.",
    "displayLanguageLabel": "Lenguaje",
    "languageUpdated": "Idioma de la pantalla actualizado.",
    "emailTitle": "Dirección de correo electrónico",
    "newEmail": "Nuevo correo electrónico",
    "currentPassword": "Contraseña actual",
    "emailPasswordPlaceholder": "Obligatorio para cambiar el correo electrónico",
    "save": "Guardar",
    "cancel": "Cancelar",
    "changeEmail": "Cambiar dirección de correo electrónico",
    "passwordTitle": "Contraseña",
    "passwordSharedWarning": "Esta contraseña se comparte entre tu app de estudio de OktoGo y el portal de Management. Cambiarla aquí actualiza tu inicio de sesión en ambos.",
    "passwordConfirmTitle": "¿Cambiar la contraseña en ambas plataformas?",
    "passwordConfirmBody": "Esto cambia tu inicio de sesión tanto en la app de estudio de OktoGo (app.oktogo.ai) como en Management, usando el mismo correo electrónico.",
    "passwordConfirmCancel": "Cancelar",
    "passwordConfirmSubmit": "Sí, cambiar la contraseña",
    "newPassword": "Nueva contraseña",
    "confirmNewPassword": "Confirmar nueva contraseña",
    "updatePassword": "Actualizar contraseña",
    "changePassword": "Cambiar contraseña",
    "verticalLabel": "Vertical",
    "notificationTitle": "Preferencias de notificación",
    "escalationAlerts": "Alertas de escalamiento",
    "escalationAlertsDesc": "Push cuando un chat se escala para revisión o toma humana (siempre activo). El correo de escalamiento con motivo y extracto del chat es distinto del correo de caducidad de sesión de WhatsApp. Pronto habrá una opción en Cuenta para silenciar solo el correo de escalamiento; el push sigue activo.",
    "weeklySummary": "Resumen semanal",
    "weeklySummaryDesc": "Recibir un informe de rendimiento semanal",
    "connectionWarnings": "Advertencias de conexión",
    "connectionWarningsDesc": "Alerta cuando se pierde una conexión de plataforma",
    "notificationsSaved": "Preferencias de notificación guardadas.",
    "verticalFitness": "Fitness / estudio",
    "verticalStr": "Alquiler temporal",
    "toastCurrentPasswordForEmail": "Introduzca su contraseña actual para cambiar el correo electrónico.",
    "toastVerificationEmailSent": "Correo electrónico de verificación enviado a la nueva dirección.",
    "toastEmailUpdateFailed": "Error al actualizar el correo electrónico.",
    "toastPasswordMismatch": "Las contraseñas no coinciden.",
    "toastPasswordUpdated": "Contraseña actualizada.",
    "toastPasswordUpdateFailed": "Error al actualizar la contraseña.",
    "toastVerticalUpdated": "Producto vertical actualizado.",
    "toastVerticalUpdateFailed": "Error al actualizar vertical.",
    "toastPreferencesSaveFailed": "No se pudo guardar.",
    "studioNameTitleStudio": "Nombre del estudio",
    "studioNameTitleProperty": "Nombre de la propiedad",
    "studioNameHint": "Así aparece tu espacio en la app, las notificaciones y los mensajes para clientes.",
    "studioNameContextHint": "Selecciona un solo estudio para editar su nombre.",
    "studioNameValidation": "El nombre debe tener entre 2 y 60 caracteres.",
    "toastStudioNameUpdated": "Nombre del estudio actualizado.",
    "toastPropertyNameUpdated": "Nombre de la propiedad actualizado.",
    "toastStudioNameUpdateFailed": "No se pudo actualizar el nombre."
  },
  "auth": {
    "languageSwitcherAria": "Idioma de la interfaz",
    "placeholderEmailExample": "tu@estudio.com",
    "placeholderPassword": "••••••••",
    "placeholderPasswordCreate": "Establece tu contraseña",
    "placeholderPasswordConfirm": "Repite tu contraseña",
    "placeholderStudioName": "Nombre de tu estudio",
    "onboardingSelectPlatform": "Selecciona tu plataforma",
    "onboarding2faSecret": "Introduce tu secreto 2FA o código de respaldo",
    "login": {
      "subtitle": "Inicia sesión en tu estudio",
      "lockout": "Demasiados intentos fallidos. Vuelve a intentarlo en {{minutes}} minutos.",
      "emailLabel": "Correo electrónico",
      "passwordLabel": "Contraseña",
      "passwordPlaceholder": "Introduce tu contraseña",
      "rememberMe": "Recordarme",
      "rememberMeHelpOn": "Mantén la sesión iniciada en este dispositivo aunque cierres el navegador.",
      "rememberMeHelpOff": "Se cerrará tu sesión al cerrar el navegador.",
      "logIn": "Iniciar sesión",
      "forgotPassword": "¿Olvidaste la contraseña?",
      "orDivider": "o",
      "continueWithGoogle": "Continuar con Google",
      "noAccount": "¿No tienes cuenta?",
      "createAccount": "Crear una →",
      "sessionExpiredToast": "Tu sesión ha caducado. Vuelve a iniciar sesión.",
      "pilotInviteHandoff": "Tu invitación piloto está aceptada. Inicia sesión con la contraseña que acabas de crear.",
      "errorIncorrectCredentials": "Correo o contraseña incorrectos.",
      "errorEmailNotVerified": "La dirección de correo no está verificada.",
      "resendVerificationAction": "Reenviar correo de verificación",
      "resendVerificationToast": "Correo de verificación enviado. Revisa tu bandeja de entrada.",
      "resendVerificationRateLimited": "Demasiados intentos. Espera 15 minutos antes de solicitar otro correo.",
      "goToVerificationPage": "Ir a la página de verificación →",
      "errorNetwork": "No se puede alcanzar el servidor. Inicia la API (p. ej. npm run dev o dev:server) e inténtalo de nuevo.",
      "errorGooglePopupBlocked": "El navegador bloqueó una ventana emergente. Permite ventanas emergentes para este sitio e inténtalo de nuevo.",
      "errorGoogleSignIn": "El inicio de sesión con Google falló. Inténtalo de nuevo o usa correo y contraseña."
    },
    "register": {
      "subtitle": "Crea tu cuenta",
      "studioNameLabel": "Nombre del estudio",
      "emailLabel": "Correo electrónico",
      "passwordLabel": "Contraseña",
      "createAccount": "Crear cuenta",
      "orDivider": "o",
      "continueWithGoogle": "Continuar con Google",
      "hasAccount": "¿Ya tienes cuenta?",
      "logIn": "Iniciar sesión →",
      "validationStudioName": "El nombre del estudio debe tener al menos 2 caracteres.",
      "validationEmail": "Introduce un correo electrónico válido.",
      "validationPassword": "La contraseña debe tener al menos 8 caracteres, 1 letra y 1 número.",
      "registrationFailed": "El registro falló. Inténtalo de nuevo.",
      "duplicateEmailLead": "Ya existe una cuenta con este correo.",
      "duplicateEmailLink": "Iniciar sesión →"
    },
    "forgot": {
      "subtitle": "Restablece tu contraseña",
      "emailLabel": "Correo electrónico",
      "sentLead": "Revisa tu bandeja de entrada. Hemos enviado un enlace para restablecer la contraseña.",
      "backToLogin": "← Volver al inicio de sesión",
      "testResetLink": "(Test: ir a la página de restablecer contraseña)",
      "sendResetLink": "Enviar enlace de restablecimiento",
      "errorGeneric": "Algo salió mal. Inténtalo de nuevo.",
      "networkError": "Error de red. Inténtalo de nuevo."
    },
    "reset": {
      "invalidLink": "Este enlace de restablecimiento no es válido o ha caducado.",
      "requestNewLink": "Solicitar un nuevo enlace →",
      "tokenUsed": "Este enlace ya se ha utilizado.",
      "requestNewOne": "Solicitar un nuevo enlace →",
      "successBody": "Contraseña actualizada. Inicia sesión.",
      "goToLogin": "Ir al inicio de sesión →",
      "subtitle": "Establece una nueva contraseña",
      "newPasswordLabel": "Nueva contraseña",
      "confirmPasswordLabel": "Confirmar contraseña",
      "resetButton": "Restablecer contraseña",
      "testSimulateUsed": "(Test: simular token ya usado)",
      "errorPasswordRules": "La contraseña debe tener al menos 8 caracteres, 1 letra y 1 número.",
      "errorPasswordMismatch": "Las contraseñas no coinciden.",
      "errorTokenExpired": "Este enlace ha caducado. Solicita uno nuevo.",
      "networkError": "Error de red. Inténtalo de nuevo.",
      "errorGeneric": "Algo salió mal."
    },
    "invite": {
      "invalidToken": "Este enlace de invitación no es válido.",
      "goToLogin": "Ir al inicio de sesión →",
      "subtitle": "Acepta la invitación del equipo",
      "invalidUsed": "Esta invitación no es válida o ya se usó.",
      "expired": "Esta invitación ha caducado.",
      "expiredHint": "Pide al administrador del estudio que reenvíe tu invitación.",
      "successRedirect": "Invitación aceptada. Redirigiendo al panel…",
      "createPasswordLabel": "Crear contraseña",
      "termsPrivacy": "Acepto los Términos del servicio y la Política de privacidad.",
      "acceptButton": "Aceptar invitación",
      "validationPassword": "La contraseña debe tener al menos 8 caracteres, 1 letra y 1 número.",
      "validationTerms": "Debes aceptar los términos y la privacidad para continuar.",
      "errorAcceptFailed": "No se pudo aceptar la invitación.",
      "errorNoSession": "Invitación aceptada pero no se creó la sesión.",
      "networkError": "Error de red. Inténtalo de nuevo."
    },
    "civ": {
      "documentTitle": "Confirma tu correo — OktoGo",
      "headerSubtitle": "Al confirmar tu correo electrónico, el estudio podrá continuar con tu reserva.",
      "consent": {
        "headline": "Confirma tu identidad para {{ studioName }}",
        "body": "Esto confirma que este correo electrónico es tuyo y permite a {{ studioName }} (con tecnología de OktoGo.ai) realizar la reserva que solicitaste en {{ channelLabel }}.",
        "checkboxEmail": "Confirmo que esta dirección de correo electrónico es mía.",
        "checkboxData": "Acepto que OktoGo.ai almacene y procese mis datos personales para gestionar esta solicitud, como se describe en la <a>Política de Privacidad</a>.",
        "privacyPolicyAriaLabel": "Política de privacidad de OktoGo.ai (se abre en una pestaña nueva)",
        "confirmButton": "Confirmar y continuar",
        "confirmButtonSubmitting": "Confirmando…",
        "declineLink": "No fui yo — rechazar",
        "errorGeneric": "Algo ha salido mal. Inténtalo de nuevo o contacta con soporte.",
        "errorRateLimited": "Demasiados intentos. Espera un momento e inténtalo de nuevo.",
        "errorVersionMismatch": "Hemos actualizado esta página. Recárgala e inténtalo de nuevo."
      },
      "success": {
        "headline": "Estás verificado.",
        "body": "Ya puedes volver a tu chat de {{ channelLabel }} con {{ studioName }} para continuar. Seguiremos justo donde lo dejaste.",
        "closeHint": "Puedes cerrar esta pestaña con seguridad."
      },
      "error": {
        "expiredHeadline": "Este enlace ha caducado",
        "expiredBody": "Por seguridad, el enlace solo es válido durante un corto periodo. Responde a tu chat y te enviaremos uno nuevo.",
        "invalidHeadline": "Este enlace no es válido",
        "invalidBody": "No se ha podido reconocer el enlace. Responde a tu chat para volver a empezar.",
        "usedHeadline": "Ya confirmado",
        "usedBody": "Este correo electrónico ya ha sido confirmado. Puedes volver a tu chat para continuar.",
        "networkHeadline": "Problema de conexión",
        "networkBody": "No hemos podido conectar con OktoGo. Comprueba tu conexión a Internet e inténtalo de nuevo.",
        "networkRetryButton": "Reintentar"
      },
      "declined": {
        "headline": "Entendido — no continuaremos.",
        "body": "Hemos registrado tu rechazo. Si ha sido un error, contacta con soporte y te ayudaremos."
      },
      "terminal": {
        "contactSupport": "Contactar con soporte",
        "contactSupportAriaLabel": "Enviar un correo al soporte de OktoGo"
      }
    },
    "verify": {
      "title": "Revisa tu bandeja de entrada",
      "bodyGeneric": "Hemos enviado un enlace de verificación a tu correo. Haz clic en el enlace para verificar tu cuenta.",
      "bodyWithEmail": "Enviamos un correo de verificación a {{email}}. Haz clic en el enlace para verificar tu cuenta.",
      "linkExpiredTitle": "Tu enlace de verificación ha caducado.",
      "resendLink": "Reenviar correo de verificación",
      "rateLimited": "Demasiados intentos. Espera 15 minutos antes de solicitar otro correo.",
      "resendButton": "Reenviar correo de verificación",
      "resendButtonDone": "Correo de verificación reenviado ✓",
      "footerHint": "¿No lo recibiste? Revisa spam o solicita un nuevo enlace.",
      "testExpired": "(Test: simular token caducado)"
    },
    "verifyToken": {
      "loadingTitle": "Verificando tu correo",
      "loadingBody": "Espera mientras confirmamos tu cuenta.",
      "successTitle": "Correo verificado",
      "successBody": "Tu cuenta está verificada. Ya puedes iniciar sesión.",
      "invalidTitle": "Enlace de verificación no válido",
      "invalidBody": "Este enlace no es válido. Solicita un nuevo correo de verificación desde la página de inicio de sesión.",
      "expiredTitle": "Enlace de verificación caducado",
      "expiredBody": "Este enlace ha caducado. Solicita un nuevo correo de verificación desde la página de inicio de sesión.",
      "errorTitle": "Error de verificación",
      "errorBody": "No pudimos verificar tu correo. Inténtalo de nuevo o solicita un nuevo enlace.",
      "goToLogin": "Ir a iniciar sesión"
    },
    "verifyEmailChange": {
      "loadingTitle": "Verificando tu nuevo correo",
      "loadingBody": "Espera mientras confirmamos tu cambio de correo.",
      "successTitle": "Correo actualizado correctamente",
      "successBody": "Tu dirección de correo ha sido actualizada.",
      "successBodyWithEmail": "Tu nuevo correo de acceso es {{email}}.",
      "invalidTitle": "Enlace de cambio de correo no válido",
      "invalidBody": "Este enlace de cambio de correo no es válido o ya fue usado.",
      "expiredTitle": "Enlace de cambio de correo caducado",
      "expiredBody": "Este enlace de cambio de correo ha caducado. Inicia un nuevo cambio desde Configuración.",
      "errorTitle": "No se pudo verificar el cambio de correo",
      "errorBody": "Ocurrió un error al verificar tu cambio de correo. Inténtalo de nuevo más tarde.",
      "goToLogin": "Ir a iniciar sesión →"
    }
  },
  "common": {
    "search": "Buscar...",
    "filter": "Filtro",
    "sort": "Ordenar",
    "apply": "Aplicar",
    "applyWithCount": "Aplicar ({{count}})",
    "reset": "Reiniciar",
    "clearAll": "Borrar todo",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "loading": "Cargando…",
    "nameAZ": "Nombre A-Z",
    "nameZA": "Nombre de Z a A",
    "moreFilters": "+{{count}} más",
    "moreFiltersAria": "{{count}} filtros más activos — abrir lista",
    "additionalFilters": "Filtros adicionales",
    "removeFilterAria": "Eliminar filtro {{label}}",
    "loadingRoute": "Cargando página…",
    "loadingContent": "Cargando contenido…",
    "loadingTable": "Cargando tabla…"
  },
  "dashboard": {
    "todaysStats": "Estadísticas de hoy",
    "needsAttention": "Necesita su atención",
    "seeAllChats": "Todos los chats",
    "badgeEscalated": "Escalado",
    "badgeDraftReady": "✏ BORRADOR LISTO",
    "allClear": "¡Todo despejado! No hay conversaciones activas en este momento.",
    "weeklySummary": "Resumen semanal",
    "conversationsByIntent": "Conversaciones por intención",
    "autoVsManual": "Auto-manipulado vs Manual",
    "legendAiHandled": "AI manejado",
    "legendManual": "Manual",
    "relativeJustNow": "Justo ahora",
    "relativeMinsAgo": "Hace {{count}} min",
    "relativeOneHourAgo": "Hace 1 hora",
    "relativeHoursAgo": "Hace {{count}}h",
    "relativeOneDayAgo": "Hace 1d",
    "relativeDaysAgo": "Hace {{count}}d",
    "intentApi": {
      "booking": "Reserva",
      "rebooking": "Transferir contribución",
      "cancellation": "Cancelar",
      "info": "Información",
      "schedule": "Horario",
      "account": "Cuenta",
      "other": "Otros"
    },
    "badgeSessionExpiring": "⏱ SESIÓN",
    "sessionExpiringTileWindow": "La ventana de texto libre se cierra {{time}}",
    "sessionBannerTitle": "Las respuestas de WhatsApp pueden limitarse pronto",
    "sessionBannerBody": "Al menos un chat escalado está a punto de cerrar la ventana de texto libre. Abre Chats para responder a tiempo.",
    "sessionBannerDismiss": "Ocultar",
    "sessionBannerOpenChats": "Abrir chats filtrados",
    "relativeUntilShort": "quedan {{time}}"
  },
  "chats": {
    "loadingChats": "Cargando chats...",
    "noConversations": "No se han encontraron conversaciones.",
    "noConversationsMatchFilters": "Ninguna conversación coincide con tu búsqueda o filtros.",
    "listLoadFailed": "No se pudieron cargar las conversaciones. Inténtalo de nuevo.",
    "studioContextRequired": "El contexto del estudio no está configurado correctamente. Cambia a un estudio concreto o inténtalo de nuevo.",
    "studioContextRetry": "Reintentar",
    "studioContextSwitchStudio": "Cambiar de estudio",
    "unreadConversation": "Conversación sin leer con {{name}}",
    "unreadConversationCount": "Conversación sin leer con {{name}}, {{count}} mensajes sin leer",
    "session": {
      "filterBarTitle": "Filtrado: sesión por expirar",
      "filterBarHint": "Muestra hilos cuya sesión está por cerrarse o ya expiró para texto libre.",
      "clearSessionFilter": "Mostrar todos los chats",
      "filterEmpty": "Ningún chat coincide con el filtro de sesión en esta vista. Quita el filtro o cambia de estudio.",
      "bannerExpiringTitle": "Sesión de WhatsApp a punto de cerrarse",
      "bannerExpiringBody": "Aún puedes enviar texto libre durante {{time}}. Después, Meta puede exigir una plantilla aprobada o un nuevo mensaje del cliente.",
      "bannerExpiredTitle": "Sesión de WhatsApp cerrada para texto libre",
      "bannerExpiredBody": "Esta conversación está fuera de la ventana de 24 h del cliente. El envío puede fallar hasta que uses una plantilla aprobada o el cliente vuelva a escribir.",
      "composerExpiredHelp": "Las respuestas libres están bloqueadas. Elige una plantilla de mensaje aprobada en el panel de borrador de arriba.",
      "composerClosedInstagram": "Han pasado más de 7 días. Pide al cliente que te escriba de nuevo antes de poder responder.",
      "rowAriaExpiringWhatsApp": "Sesión de WhatsApp a punto de expirar",
      "rowAriaExpiredWhatsApp": "Sesión de WhatsApp expirada para texto libre",
      "rowTooltipExpiringWhatsApp": "La sesión se cierra en {{time}}",
      "rowTooltipExpiredWhatsApp": "Sesión expirada — plantillas o nuevo mensaje del cliente",
      "rowAriaSessionExpiring": "Sesión de mensajería a punto de expirar",
      "rowAriaSessionExpired": "Sesión de mensajería expirada para texto libre",
      "rowTooltipExpiringInstagram": "La ventana de respuesta se cierra en {{time}}",
      "rowTooltipExpiredInstagram": "Fuera de 24 h — solo respuestas manuales, hasta 7 días",
      "bannerExpiringTitleInstagram": "Ventana de respuesta cerrándose pronto",
      "bannerExpiringBodyInstagram": "Respuestas aún posibles durante {{time}}. Responde pronto o espera un nuevo mensaje del cliente.",
      "bannerExpiredTitleInstagram": "Fuera de la ventana de respuesta de 24 horas",
      "bannerExpiredBodyInstagram": "Fuera de la ventana de 24 horas (hasta 7 días): Solo respuesta manual, o Revisa la respuesta sugerida, edítala y envía manualmente.",
      "bannerClosedTitleInstagram": "No se puede responder en Instagram",
      "bannerClosedBodyInstagram": "Han pasado más de 7 días. Pide al cliente que te escriba de nuevo.",
      "headerSupportWindowInstagram": "Ventana de soporte · hace {{time}}"
    },
    "customerInfo": "Información del cliente",
    "customerInfoTitle": "Información del cliente",
    "details": {
      "title": "Detalles del cliente",
      "show": "Mostrar detalles del cliente",
      "hide": "Ocultar detalles del cliente",
      "collapseAria": "Contraer el panel de detalles del cliente",
      "expandAria": "Expandir el panel de detalles del cliente",
      "resizeAria": "Redimensionar el panel de detalles del cliente",
      "placeholderLoading": "Cargando detalles del cliente…",
      "sectionGeneral": "General",
      "sectionStudios": "Studios",
      "sectionDocuments": "Documentos",
      "sectionClasses": "Clases",
      "upcomingClassesToggle": "Clases próximas más cercanas",
      "upcomingClassesEmpty": "—",
      "classesLast": "Última",
      "classesNext": "Próxima",
      "confirmIdentity": "Confirmar identidad",
      "confirmIdentityHelp": "Marca a este cliente como identificado en este chat y desbloquea las acciones de aprobación de borrador bloqueadas."
    },
    "composer": {
      "collapseAria": "Contraer el campo de respuesta",
      "expandAria": "Expandir el campo de respuesta"
    },
    "escalated": "Escalado",
    "escalatedDraftPending": "Respuesta sugerida lista — revisa antes de enviar",
    "escalationKind": {
      "soft": "Requiere revisión",
      "hard": "Intervención humana"
    },
    "escalationFamily": {
      "human_requested": "El cliente pidió una persona",
      "tool_or_platform_failure": "Fallo de herramienta o plataforma",
      "availability_unverified": "Disponibilidad no verificada",
      "no_availability": "Sin clases reservables",
      "account_read_failed": "Fallo al leer la cuenta",
      "conversation_stall": "Conversación estancada",
      "low_confidence_or_scope": "Fuera de alcance o dudoso",
      "frustration": "Cliente frustrado",
      "max_exchanges": "Máximo de intercambios alcanzado",
      "identity_verification": "Verificación de identidad necesaria",
      "policy_restricted": "Tema restringido",
      "manual": "Escalado manualmente",
      "ai_unavailable": "IA no disponible",
      "named_set_unfinished": "Cancelación sin terminar",
      "cancellation_refused": "Cancelación rechazada"
    },
    "leadWhy": {
      "structured": "Desde anuncio",
      "inferred": "Inferido"
    },
    "campaignLeadPreparation": {
      "title": "Bienvenida de campaña preparada",
      "closedTitle": "Episodio de campaña cerrado",
      "activeTitle": "Bienvenida de campaña activa",
      "notSent": "No enviado",
      "closed": "Cerrado",
      "active": "Activo",
      "activeBody": "El proveedor aceptó el mensaje de bienvenida de la campaña. El episodio espera que el cliente elija un paquete.",
      "closedBody": "La automatización de campaña se detuvo para este episodio.",
      "terminal": {
        "purchase_verified": "Compra verificada",
        "member_discovered": "Miembro existente encontrado",
        "explicit_decline": "El cliente rechazó",
        "manager_takeover": "Un responsable tomó el control"
      },
      "awaitingPack": "Esperando la elección del paquete",
      "packSelected": "Paquete seleccionado: {{name}}",
      "linkReady": "Enlace de compra listo: {{name}}",
      "purchaseClaimUnverified": "Compra informada · se requiere verificación",
      "bodyAuto": "Los datos de la campaña están fijados. El mensaje de bienvenida está en cola para el envío automático.",
      "bodyManual": "Los datos de la campaña están fijados. Revisa y envía el mensaje de bienvenida desde la respuesta sugerida de abajo.",
      "modeAuto": "Preparación automática · envío en cola",
      "modeManual": "Preparación manual · revisión obligatoria",
      "campaign": "{{name}} · versión {{version}}",
      "campaignFallback": "Campaña · versión {{version}}",
      "packs": "Paquetes preparados",
      "purchaseLink": "Enlace de compra"
    },
    "resolved": "Resuelto",
    "resolvedButton": "Marcar como resuelto",
    "messageDeliveryFailedHumanAgentTitle": "No se pudo entregar esta respuesta de Instagram",
    "messageDeliveryFailedHumanAgentBody": "El agente humano de Instagram aún no está aprobado para esta aplicación, por lo que este mensaje no pudo llegar al cliente. Pídele que te escriba de nuevo para reabrir las respuestas gratuitas, o continúa en WhatsApp si está conectado.",
    "messageDeliveryFailedBubble": "No llegó al cliente",
    "resolve": "Resolver",
    "escalate": "Escalar",
    "archive": "Archivo",
    "moreChatActions": "Acciones de chat",
    "chatIdLabel": "ID del chat",
    "loadingOlder": "Cargando mensajes anteriores",
    "loadOlderMessages": "Cargar mensajes anteriores",
    "customerFallback": "Cliente",
    "senderSystem": "Sistema",
    "loadingMessages": "Cargando mensajes",
    "draftBlockedDefault": "El cliente debe ser identificado antes de aprobar las acciones de la cuenta.",
    "draftBlockedHumanHandling": "Esta conversación ya se ha transferido a tu equipo — esta sugerencia puede estar respondiendo a un mensaje anterior.",
    "draftStaleHeadReleased": "La conversación ha avanzado desde que se escribió esta respuesta.",
    "draftStaleHeadReleasedRecovery": "Edítala antes de enviarla, o responde con tus propias palabras.",
    "draftStaleHeadReleasedRefusal": "Esta respuesta sugerida ya no está actualizada — la conversación ha avanzado desde que se escribió. Cambia el texto antes de enviarlo, o responde con tus propias palabras.",
    "listJustNow": "Justo ahora",
    "listMinsShort": "Hace {{count}}m",
    "listHoursShort": "Hace {{count}}h",
    "listDaysShort": "Hace {{count}}d",
    "threadToday": "Hoy",
    "threadYesterday": "Ayer",
    "emojiSearchPlaceholder": "Buscar emoji",
    "emojiSkinToneAria": "Cambiar tono de piel del emoji",
    "emojiCategoryRecent": "Emojis recientes",
    "emojiCategoryAll": "Todos los emojis",
    "emojiCategorySmileys": "Caritas y personas",
    "emojiCategoryPeople": "Gestos y personas",
    "emojiCategoryHearts": "Corazones y celebraciones",
    "emojiCategoryTravel": "Viajes y lugares",
    "emojiCategorySymbols": "Símbolos y estado",
    "resolvedModalConfirm": "Marcar como resuelto",
    "typeMessagePlaceholder": "Escribe un mensaje…",
    "editTitle": "Editar",
    "senderAi": "AI",
    "senderTeam": "Equipo",
    "connectPlatformHint": "Conecta una plataforma de reservas {{listingFragment}} en → Canales de configuración para mostrar el contexto del miembro o huésped vinculado aquí.",
    "connectPlatformListingFragment": "o anuncio",
    "connectPlatformListingEmpty": "",
    "searchManually": "Búsqueda manual",
    "trial": "De prueba",
    "firstTrial": {
      "staffHint": {
        "scenario1": "Primera prueba — escenario 1 (sin cuenta en la plataforma de reservas). Solo para el equipo.",
        "scenario2": "Primera prueba — escenario 2 (con cuenta en la plataforma, nuevo en tu estudio). Solo para el equipo."
      },
      "linksNotReady": {
        "title": "Falta enlace de primera prueba",
        "reason": {
          "missing_trial_registration_link": "Añade el enlace de registro / prueba antes de que Copilot pueda enviar automáticamente este flujo de prueba.",
          "missing_studio_trial_booking_link": "Añade el enlace del estudio antes de que Copilot pueda enviar automáticamente este flujo de prueba.",
          "unknown": "Añade los enlaces requeridos de primera prueba antes de que Copilot pueda enviar automáticamente este flujo de prueba."
        },
        "cta": "Abrir Información general"
      }
    },
    "completedWriteClash": {
      "title": "El borrador contradice una acción ya completada",
      "body": "La plataforma de reservas confirma que esta acción se completó en este turno, pero el borrador sigue diciendo al cliente que no tiene derecho. Edita la respuesta antes de aprobarla."
    },
    "groundedFailure": {
      "title": "La respuesta basada en hechos necesita revisión",
      "facts": "Hechos encontrados",
      "reason": "Problema de verificación"
    },
    "proposedAction": {
      "FIRST_TRIAL_LINKS_NOT_READY": "Configura los enlaces de prueba en Datos del estudio antes de que Copilot pueda enviar automáticamente este flujo de prueba.",
      "GROUP_MANUAL_FULFILLMENT": "Las reservas de grupo o equipo requieren gestión manual por el equipo del estudio."
    },
    "campaignSend": {
      "campaign_ended": "Esta campaña ha terminado o ya no está activa, por lo que el mensaje de bienvenida no se envió.",
      "instagram_window_closed": "La ventana de respuesta de Instagram de este cliente se ha cerrado, por lo que el mensaje de bienvenida no se envió.",
      "human_handling": "Un miembro del equipo se ha hecho cargo de esta conversación, por lo que el mensaje de bienvenida de la campaña no se envió.",
      "customer_is_member": "Este cliente ya es miembro, por lo que el mensaje de bienvenida de la campaña no se envió.",
      "newer_customer_message": "El cliente volvió a escribir después de preparar este mensaje de bienvenida, por lo que no se envió.",
      "campaign_paused": "El envío de campañas está en pausa para este estudio en este momento, por lo que el mensaje de bienvenida no se envió.",
      "instagram_not_connected": "No se pudo confirmar la conexión de Instagram de este estudio. Revisa la conexión en Ajustes y vuelve a intentarlo.",
      "send_in_progress": "Otro envío para este cliente sigue en curso. Espera a que termine antes de volver a intentarlo; puede tardar un minuto.",
      "cooldown_or_capacity": "Este cliente ha alcanzado por ahora el límite de mensajes de bienvenida de campaña, por lo que el mensaje no se envió.",
      "draft_changed": "Este borrador ya no coincide con el mensaje de campaña preparado. Actualiza la conversación antes de volver a intentarlo.",
      "group_booking_active": "Hay una propuesta de reserva de grupo todavía abierta en esta conversación, por lo que el mensaje de bienvenida de la campaña no se envió. Resuelve o descarta primero esa propuesta.",
      "no_customer_message": "Todavía no hay ningún mensaje del cliente en esta conversación, por lo que el mensaje de bienvenida de la campaña no se envió.",
      "internal": "No se pudo enviar el mensaje de bienvenida de la campaña porque falló una comprobación interna. Vuelve a intentarlo más tarde o contacta con soporte.",
      "customer_refused": "Este cliente rechazó la campaña, por lo que no se envió ningún mensaje de bienvenida.",
      "customer_reply_pending_check": "La última respuesta del cliente todavía se está comprobando, por lo que el mensaje de bienvenida aún no se envió. Vuelve a intentarlo en un momento.",
      "campaign_updated": "La campaña se modificó después de preparar este mensaje de bienvenida, así que aún no se envió. El mensaje ahora coincide con la oferta actual. Revísalo y vuelve a pulsar Enviar.",
      "campaign_updated_edited": "La campaña se modificó después de preparar este mensaje de bienvenida, así que aún no se envió. Se ha conservado tu texto editado. Revisa los paquetes y precios y vuelve a pulsar Enviar.",
      "welcome_too_long": "Este mensaje de bienvenida es demasiado largo para un solo mensaje de Instagram, así que no se envió. Acórtalo y vuelve a pulsar Enviar.",
      "welcome_capacity_reached": "Este cliente ya ha recibido el máximo de dos mensajes de bienvenida de campaña de este estudio, por lo que el mensaje no se envió.",
      "welcome_cooldown_active": "Este cliente recibió un mensaje de bienvenida de campaña de este estudio en los últimos 30 días, por lo que el mensaje no se envió. Se podrá enviar una nueva bienvenida cuando pasen los 30 días.",
      "campaign_episode_active": "Todavía hay una conversación de campaña en curso con este cliente, por lo que no se envió un segundo mensaje de bienvenida.",
      "campaign_episode_ended": "Una conversación de campaña anterior con este cliente ya terminó, por lo que el mensaje de bienvenida no se envió.",
      "welcome_delivery_unknown": "Es posible que un envío anterior de este mensaje de bienvenida ya haya llegado al cliente, por lo que no se volvió a enviar."
    },
    "confirmObject": {
      "cardTitleBooking": "Reserva por confirmar",
      "cardTitleCancel": "Cancelación por confirmar",
      "cardTitleRebook": "Cancelar y reservar",
      "cardTitleIdentity": "Identidad por confirmar",
      "customerLabel": "Cliente",
      "classLabel": "Clase",
      "classIdLabel": "Id de clase",
      "dateLabel": "Fecha",
      "timeLabel": "Hora",
      "instructorLabel": "Instructor",
      "bookingRefLabel": "Ref. de reserva",
      "rebookFromLabel": "Cancelar",
      "rebookToLabel": "Reservar",
      "cancelSetAnd": "y",
      "cancelSetUnknownClass": "Una clase (detalles no disponibles)",
      "contactLabel": "Contacto",
      "contactMissing": "No hay correo, teléfono ni usuario de Instagram en este chat.",
      "itineraryPartial": "El nombre de la clase, la fecha y la hora local aún no están en este payload. Confirmar igual ejecuta la escritura aprobada.",
      "confirmBooking": "Confirmar reserva",
      "confirmCancellation": "Confirmar cancelación",
      "confirmRebook": "Confirmar cancelar y reservar",
      "confirmIdentity": "Confirmar identidad",
      "abort": "Abortar",
      "abortUnavailable": "Descartar aún no está disponible. Confirmar igual ejecuta; ocultar esta tarjeta no cancelaría la escritura pendiente.",
      "bookingInProgress": "Reserva en curso…",
      "bookingStillRunning": "La reserva sigue en curso. Puedes seguir en otros chats; el resultado aparecerá aquí.",
      "abortIdentityHint": "No confirma la identidad. No se envía ninguna petición.",
      "claimLive": "{{name}} está terminando esto ahora. Confirmar y Abortar están bloqueados temporalmente.",
      "claimLiveNoName": "Otro gestor está terminando esto ahora. Confirmar y Abortar están bloqueados temporalmente.",
      "claimStale": "El último intento no se completó. Puedes intentarlo de nuevo."
    },
    "groupBooking": {
      "listBadgeAria": "Solicitud de grupo o equipo",
      "listTooltip": "Esta conversación tiene un borrador pendiente para una solicitud de reserva con forma de grupo o evento de equipo.",
      "draftCardTitle": "Grupo / equipo",
      "cardTitle": "Grupo / equipo",
      "extractedPartySize": "Tamaño de grupo indicado: {{count}}",
      "partySize": "Tamaño de grupo indicado: {{count}}",
      "participantsLabel": "Participantes",
      "checklistLabel": "Lista de control del manager",
      "checklistUnknown": "Elemento: {{key}}",
      "overrideReasonUnknown": "{{key}}",
      "status": {
        "collecting": "Recopilando datos de la lista",
        "awaitingManager": "En espera de revisión del manager",
        "awaitingApproval": "En espera de tu aprobación",
        "running": "Automatización en curso",
        "done": "Completado",
        "failed": "Error en la automatización",
        "manualFallback": "Se requiere gestión manual",
        "notApplicable": "No aplicable"
      },
      "checklist": {
        "party_size": "Aclarar el número final y los rangos de edad",
        "date_window": "Confirmar fechas preferidas o ventana horaria",
        "offering_type": "Confirmar tipo de clase, paquete o alcance de alquiler privado",
        "deposit_or_po": "Depósito, orden de compra o contacto de facturación si aplica",
        "bill_to": "Entidad de facturación y datos fiscales si se requieren",
        "roster_complete": "Confirmar que la lista está completa (nombres y contactos)",
        "class_slot": "Confirmar clase, sesión o franja horaria",
        "book_without_product": "Registrar reserva sin producto vinculado si hace falta",
        "invoice_externally": "Facturar fuera de la plataforma si es necesario",
        "terms_confirm_on_site": "Confirmar términos y políticas in situ si aplica"
      },
      "overrideReason": {
        "group_policy_overrode_auto_send": "El envío automático se anuló en este turno por la política de grupo / equipo — revísalo antes de enviar."
      }
    },
    "escalateModalTitle": "Escalar conversación",
    "escalateModalBody": "Esto notificará al equipo para el seguimiento manual.",
    "resolvedModalTitle": "Marcar como resuelto",
    "resolvedModalBody": "Esta conversación se marcará como resuelta.",
    "filter": {
      "panelTitle": "Filtro",
      "panelDescription": "Selecciona los filtros de chat y aplícalos a la lista de conversaciones.",
      "closeAria": "Cerrar panel de filtros",
      "sectionStatus": "ESTADO",
      "sectionIntention": "INTENCIÓN",
      "sectionCustomerId": "ID DE CLIENTE",
      "sectionChannel": "CANAL",
      "statusUnread": "//No leído//",
      "statusNeedsReview": "Revisión de necesidades",
      "statusEscalated": "Escalado",
      "statusAiHandled": "AI Handled",
      "statusResolved": "Resuelto",
      "statusNeedsFollowup": "neecsita seguimiento"
    },
    "sort": {
      "newest": "Recientes primero",
      "oldest": "Antiguos primero",
      "unreadFirst": "Primero sin leer",
      "escalatedFirst": "Escalado primero",
      "sessionExpiringFirst": "Urgencia de sesión",
      "byStatus": "Sincronizar el estado de confirmación de la reserva con el pedido Woo correspondiente"
    },
    "intentChip": {
      "newBooking": "Nueva Reserva",
      "rebooking": "Cambio de reserva",
      "cancellation": "Cancelación",
      "generalInfo": "Información general",
      "schedule": "Horario",
      "membership": "Suscripción",
      "other": "Otros"
    },
    "customerId": {
      "identified": "Identificada",
      "idPending": "ID pendiente",
      "unmatched": "Inigualables",
      "generalInquiry": "Consulta de tipo general"
    },
    "leadBadge": {
      "label": "Lead"
    },
    "channel": {
      "instagram": "Instagram",
      "whatsapp": "WhatsApp",
      "facebook": "Facebook Messenger",
      "email": "Correo electrónico"
    },
    "email": {
      "from": "De",
      "to": "Para",
      "cc": "Cc",
      "authorCustomer": "Cliente",
      "subject": "Asunto",
      "sendFromMailbox": "Las respuestas se envían desde {{mailbox}}",
      "emptyConnectHint": "Conecta el correo en Ajustes → Canales o desde la cabecera para ver los hilos aquí.",
      "deliveryFailed": "Entrega fallida",
      "showPreviousMessages": "Mostrar mensajes anteriores",
      "hidePreviousMessages": "Ocultar mensajes anteriores",
      "inlineImageUnavailable": "Imagen integrada no disponible",
      "attachmentDownloadFailed": "No se pudo descargar el adjunto",
      "grantExpiredBannerTitle": "Reconexión de correo requerida",
      "grantExpiredBannerBody": "El envío está desactivado hasta que reconectes el buzón.",
      "grantExpiredBannerCta": "Abrir Ajustes → Canales",
      "grantExpiredComposer": "Reconecta el correo en Ajustes para enviar mensajes.",
      "composer": {
        "send": "Enviar",
        "replyAll": "Responder a todos",
        "bold": "Negrita",
        "italic": "Cursiva",
        "underline": "Subrayado",
        "bulletList": "Lista con viñetas",
        "numberedList": "Lista numerada",
        "link": "Insertar enlace",
        "insertImage": "Insertar imagen",
        "attachFile": "Adjuntar archivo",
        "bodyAria": "Cuerpo del mensaje de correo",
        "linkPrompt": "Introduce la URL del enlace",
        "linkUrlInvalid": "Introduce una dirección web válida (p. ej. example.com)",
        "imageTypeError": "Elige un archivo de imagen",
        "attachmentMaxCount": "Máximo {{count}} adjuntos",
        "attachmentOversize": "El adjunto es demasiado grande",
        "attachmentUploadFailed": "No se pudo subir el adjunto",
        "attachmentRemoveFailed": "No se pudo quitar el adjunto",
        "inlineImageNotReady": "La imagen insertada no está lista para enviar. Espera si hay una subida en curso, o quítala e inténtalo de nuevo.",
        "removeAttachment": "Quitar {{name}}",
        "bodyCharCount": "{{count}} / {{max}} caracteres"
      }
    },
    "provenance": {
      "autoAi": "Auto AI",
      "approvedAi": "IA aprobada",
      "team": "Equipo",
      "sessionNudge": "OktoGo — recordatorio de sesión"
    },
    "infoRow": {
      "phone": "Teléfono",
      "instagram": "Instagram",
      "email": "Correo electrónico"
    },
    "handling": {
      "autoSendAll": "Todos los temas: envío automático",
      "autoSendNone": "Todos los temas: borrador para aprobación",
      "autoSendMixed": "Mixto: algunos se envían automáticamente, otros necesitan aprobación",
      "teamStyleOn": "Estilo de equipo activado",
      "teamStyleOff": "Estilo de equipo desactivado",
      "autoLabelPrefix": "Etiqueta automática: {{label}}",
      "tooltip": "Cómo maneja la IA este hilo en OktoGo. La distribución por canales sigue utilizando tu cuenta de empresa de WhatsApp o Instagram conectada."
    },
    "archiveChatError": "No se ha podido archivar el chat",
    "archiveChatSuccess": "Chat archivado",
    "archiveDialogTitle": "Archivar chat",
    "archiveDialogBody": "¿Seguro que deseas archivar este chat?",
    "archiveDangerTitle": "Zona de peligro",
    "archiveDangerBody": "Esta acción es irreversible en la app. La conversación se eliminará de tu lista de chat y los miembros del equipo ya no la verán aquí. El historial de mensajes se conserva para el cumplimiento, pero es posible que no se pueda acceder desde esta interfaz.",
    "archiveAnyway": "Archivar de todos modos",
    "customerWroteAgain": {
      "notice": "El cliente ha vuelto a escribir. Esta confirmación ya no está activa. El asistente está leyendo su mensaje."
    },
    "emptyStateTitle": "Seleccionar conversación",
    "emptyStateSubtitle": "Elige de la lista para ver los mensajes",
    "saveEdit": "Guardar",
    "messageEdited": "editado",
    "attachmentPhotoVideo": "Foto / Vídeo",
    "attachmentDocument": "Documento",
    "attachmentUpload": "Cargar archivo",
    "noMessages": "No hay mensajes para mostrar",
    "draftApproveSend": "Enviar",
    "identityPendingHint": "Identidad pendiente —",
    "identityApprovalSuccess": "Identidad confirmada. Ahora puedes aprobar y enviar el borrador.",
    "identityVerifiedMilestone": "Identidad verificada",
    "identityApprovalFailed": "No pudimos confirmar la identidad. Vuelve a intentarlo en un momento.",
    "identityApprovalNotAvailable": "Aún no hay un perfil de cliente vinculado. Espera a que el cliente confirme o vincula primero un perfil, y vuelve a intentarlo.",
    "identityInvalidState": "La identidad no está pendiente de aprobación en esta conversación. Actualiza e inténtalo de nuevo.",
    "draftEdit": "Editar",
    "draftDeliveredDiffers": "El texto enviado difiere del borrador aprobado.",
    "draftRegenerate": "Regenerar",
    "draftAbortFailed": "No pudimos descartar esa acción pendiente. Vuelve a intentarlo en un momento.",
    "reject": "Rechazar",
    "reportIssue": "Informar problema",
    "reportCopilotIssueMenu": "Informar problema de Copilot",
    "feedback": {
      "dialogTitleReject": "Rechazar respuesta sugerida",
      "dialogTitleReport": "Informar problema de Copilot",
      "dialogDescriptionReject": "Cuéntanos qué salió mal. La respuesta sugerida se eliminará después de enviar.",
      "dialogDescriptionReport": "Describe el problema. Tu respuesta sugerida permanecerá para que puedas editarla o enviarla.",
      "categoryLegend": "¿Cuál fue el problema?",
      "categoryRequired": "Elige una categoría para continuar.",
      "category": {
        "wrongInformation": "Información incorrecta o desactualizada",
        "wrongTone": "Tono o redacción inadecuados",
        "shouldHaveAsked": "Debería haberme preguntado antes",
        "bookingMistake": "Error de reserva",
        "misunderstood": "Malentendió la solicitud",
        "other": "Otro"
      },
      "detailsLabel": "Detalles (opcional)",
      "detailsPlaceholder": "¿Qué debería haber hecho Copilot?",
      "includeContext": "Incluir contexto de la conversación",
      "piiWarning": "No adjuntes capturas con teléfonos o datos de pago de clientes.",
      "wrongInformationHint": "Puedes actualizar los datos del estudio en",
      "studioDataLink": "Datos del estudio",
      "cancel": "Cancelar",
      "submitReject": "Rechazar",
      "submitReport": "Enviar informe",
      "submitting": "Enviando…",
      "submitThanks": "Gracias — tu comentario nos ayuda a mejorar Copilot.",
      "errorGeneric": "No pudimos enviar tu comentario. Inténtalo de nuevo.",
      "errorNoPendingDraft": "No hay un borrador pendiente para rechazar.",
      "errorRateLimited": "Has enviado varios informes recientemente. Espera unos minutos.",
      "errorForbidden": "No tienes permiso para enviar comentarios en este chat.",
      "reportedDraftLabel": "Respuesta sugerida reportada",
      "errorAttachmentUpload": "No se pudo subir esa imagen. Inténtalo de nuevo.",
      "errorUnsupportedFileType": "Tipo de archivo no compatible",
      "attachmentsLabel": "Capturas (opcional)",
      "addAttachment": "Añadir imagen",
      "attachmentOversize": "Cada imagen debe ser de 2 MB o menos.",
      "attachmentMaxCount": "Puedes adjuntar hasta 3 imágenes.",
      "attachmentsDropHint": "Pega o suelta imágenes aquí (PNG, JPEG, WebP; máx. 2 MB cada una).",
      "scenarioSuggestedLegend": "Escenario de prueba (sugerido)",
      "scenarioConfidence": "Confianza: {{level}}",
      "scenarioConfidenceHigh": "Alta",
      "scenarioConfidenceMedium": "Media",
      "scenarioConfidenceLow": "Baja",
      "scenarioChange": "Cambiar",
      "scenarioSkipMapping": "No estoy seguro / omitir asignación",
      "scenarioNoSuggestion": "No hay coincidencia automática para esta categoría. Elige manualmente u omite.",
      "scenarioPickManual": "Elegir escenario"
    },
    "whatsappTemplatePicker": {
      "title": "Seleccionar plantilla aprobada",
      "aria": "Seleccionar plantilla aprobada",
      "searchPlaceholder": "Buscar plantillas de mensaje…",
      "select": "Seleccionar",
      "insert": "Insertar",
      "inWindowHint": "El texto de la plantilla se insertará en tu borrador. Envíalo con Aprobar y enviar como de costumbre."
    },
    "whatsappTemplate": {
      "panelTitle": "Plantilla de mensaje",
      "panelSubtitle": "Fuera de la ventana de 24 horas, solo las plantillas aprobadas por Meta pueden llegar al cliente.",
      "loading": "Cargando plantillas…",
      "loadError": "No se pudieron cargar las plantillas de WhatsApp.",
      "retry": "Reintentar",
      "emptyApproved": "No hay plantillas aprobadas para este estudio. Añade o aprueba plantillas en Ajustes → Canales.",
      "templateLabel": "Plantilla",
      "templatePlaceholder": "Elegir plantilla",
      "variableLabel": "Variable {{index}}",
      "variableCountError": "Esta plantilla necesita {{count}} variable(s).",
      "previewLabel": "Vista previa",
      "sendButton": "Enviar plantilla",
      "sendSuccess": "Mensaje de plantilla en cola.",
      "sendError": "No se pudo enviar la plantilla. Inténtalo de nuevo.",
      "approveBlockedTooltip": "La aprobación en texto libre está bloqueada. Envía una plantilla de WhatsApp aprobada abajo.",
      "suggestedLabel": "Sugerido para este hilo",
      "llmSuggestedHelper": "Sugerido por IA para este hilo.",
      "suggestionRationale": {
        "supportFollowup": "Seguimiento de un mensaje reciente del cliente",
        "aiHandoff": "Traspaso a un miembro del equipo tras escalación",
        "bookingCancelled": "Contexto de cancelación de reserva",
        "classReminder": "Recordatorio de clase o reserva",
        "bookingConfirmed": "Confirmación de reserva",
        "waitlist": "Plaza en lista de espera disponible",
        "reengagement": "Reactivación tras resolución"
      }
    },
    "insertMessage": {
      "chooseTemplate": "Elegir plantilla de mensaje"
    },
    "messageTemplate": {
      "panelTitle": "Plantilla de mensaje",
      "expiredEmptyTitle": "Ventana de mensajería cerrada",
      "expiredEmptyBody": "Elige una plantilla de WhatsApp aprobada para contactar a este cliente.",
      "editVariables": "Editar variables"
    },
    "feedbackEditor": {
      "bold": "Negrita",
      "italic": "Cursiva",
      "bulletList": "Lista con viñetas",
      "orderedList": "Lista numerada",
      "emoji": "Insertar emoji",
      "markdownHint": "El formato usa Markdown. Usa Vista previa para ver cómo se verá.",
      "showPreview": "Vista previa",
      "hidePreview": "Editar"
    },
    "draftRegenerateTitle": "Regenerar",
    "draftAiDraft": "Respuesta sugerida",
    "draftReviewing": "Respuesta sugerida — en revisión",
    "draftReview": "Revisar",
    "composeManualReply": "Respuesta manual",
    "composeManualReplyPlaceholder": "Escribe tu mensaje manualmente",
    "draftSave": "Guardar borrador",
    "draftRegenerateFailed": "La regeneración ha fallado.",
    "draftRegenerateFailedRetry": "La regeneración ha fallado. Por favor, inténtelo de nuevo.",
    "draftRegenerateWsFailed": "Error en la regeneración del borrador.",
    "replySendFailed": "No hemos podido enviar su mensaje, así que lo hemos devuelto al campo de escritura. Inténtelo de nuevo en un momento.",
    "replyTooLong": "Este mensaje es demasiado largo para enviarlo. Acórtelo o adjunte el texto como archivo.",
    "replyTooLongDelta": "Este mensaje supera el límite en {{over}} caracteres. Acórtelo o adjunte el texto como archivo.",
    "actionLogExpand": "Expandir el registro de acciones de IA",
    "actionLogCollapse": "Contraer el registro de acciones de IA",
    "actionLogTitle": "Action Log",
    "actionLogCountOne": "{{count}} acción",
    "actionLogCountOther": "{{count}} acciones",
    "actionLogAttribution": "por {{name}}",
    "actionLogLabels": {
      "draft_approved": "Borrador aprobado y enviado",
      "draft_edited": "Borrador editado",
      "draft_edited_and_sent": "Borrador editado y enviado",
      "draft_regenerated": "Borrador regenerado",
      "draft_aborted": "Borrador interrumpido antes del envío",
      "manual_reply_sent": "Respuesta manual enviada",
      "whatsapp_template_sent": "Plantilla de WhatsApp enviada",
      "auto_reply_sent": "Respuesta automática enviada",
      "status_changed": "Estado cambiado",
      "identity_approved": "Identidad confirmada",
      "faq_created": "FAQ creada",
      "faq_edited": "FAQ editada",
      "faq_deleted": "FAQ eliminada",
      "toggle_changed": "Ajuste cambiado",
      "menu_answered": "Menú respondido"
    },
    "registrationTitle": "Regristro",
    "registrationSendLink": "Enlace de registro",
    "registrationAssisted": "Registro asistido",
    "registrationSendLinkButton": "Enviar enlace",
    "refundApplicable": "Aún con tiempo — el crédito de clase o el pase debería volver.",
    "refundNotApplicable": "Demasiado cerca del inicio de la clase — no vuelve ningún crédito.",
    "richCards": {
      "availabilitySpots": "{{spots}} plazas",
      "availabilitySpotsWarning": "{{spots}} plazas ⚠️",
      "bookingNoFee": "Sin cargo",
      "bookingNewClient": "Nueva cuenta de cliente creada",
      "bookingConfirmedTitle": "Reserva confirmada",
      "bookingCreditsLine": "Créditos usados: {{used}} · Restantes: {{remaining}}",
      "rebookingCancelled": "Cancelada",
      "rebookingRebooked": "Reprogramada",
      "policyRequiredNotice": "Preaviso requerido: {{value}}",
      "policyTimeUntilClass": "Tiempo hasta la clase: {{value}}",
      "policyLateFee": "Cargo por retraso: {{value}}",
      "scheduleStatusOpen": "Abierta",
      "multiBookedTitle": "{{count}} clases reservadas",
      "membershipLabel": "Membresía: {{name}}",
      "membershipUsedProgress": "{{used}} / {{total}} usados",
      "membershipRemaining": "Restantes: {{remaining}}",
      "membershipExpires": "Caduca: {{date}} ({{days}} días)",
      "membershipBookNext": "Reservar la siguiente clase",
      "membershipRenew": "Renovar — {{label}} {{price}}"
    },
    "customerPanel": {
      "noListingChannel": "No hay ningún canal de anuncios conectado",
      "noBookingPlatform": "No hay ninguna plataforma de reservas conectada",
      "memberCustomerId": "ID de miembro / cliente",
      "secondaryReference": "Referencia secundaria",
      "noMatchingGuest": "No hay ningún registro de huésped que coincida",
      "noMatchingCustomer": "No hay registro de cliente coincidente",
      "joinedLineStr": "{{line}} · {{platform}}",
      "guestNotFoundIn": "Huésped no encontrado en {{platform}}",
      "connectedPlatform": "Conectado · {{platform}}",
      "eversportsCustomerId": "ID de cliente de Eversports",
      "genericCustomerId": "{{platform}} ID DE cliente",
      "mindbodyClientId": "ID de cliente de Mindbody",
      "bsportMemberId": "ID de miembro de Bsport",
      "partnerNetworkId": "red de socios",
      "customerNotFoundIn": "Cliente no encontrado en {{platform}}"
    }
  },
  "studioData": {
    "activeStudioLimitReached": "Máximo 5 estudios activos. Archiva un estudio antes de crear otro.",
    "readOnlyBanner": "Tienes acceso de solo lectura a {{noun}}.",
    "noStudiosLinked": "No hay estudios vinculados a esta cuenta.",
    "notConfiguredTab": "Sin configurar",
    "searchStudiosAria": "Buscar estudios",
    "tabClasses": "Clases",
    "tabFaq": "Preguntas frecuentes",
    "tabGeneral": "Información general",
    "tabPolicies": "Políticas",
    "tabPrices": "Precios",
    "tabTeam": "Equipo",
    "tabUsers": "Usuarios",
    "tabCampaigns": "Campañas",
    "readOnlyHint": "Solo los propietarios y gerentes pueden editar esto.",
    "import": {
      "action": "Importar",
      "actionEmpty": "Importar desde documento",
      "titleFaq": "Importar a FAQ",
      "titlePolicies": "Importar a políticas",
      "titleGeneral": "Importar a información general",
      "tabPaste": "Pegar texto",
      "tabUpload": "Subir archivo",
      "uploadComingSoon": "La subida de archivos llegará pronto. Pega el texto por ahora.",
      "pastePlaceholder": "Pega aquí tu manual, página FAQ o documento de políticas…",
      "pasteHint": "Sugeriremos entradas estructuradas. No se guarda nada hasta que revises y apliques.",
      "pasteCharCount": "{{count}} / {{max}} caracteres (mínimo {{min}})",
      "continue": "Continuar",
      "processing": "Leyendo el documento…",
      "reviewTitle": "Revisar importación",
      "reviewSummary": "{{faq}} FAQ · {{policies}} políticas · {{general}} campos generales propuestos",
      "reviewSummaryGeneral": "{{general}} campos generales propuestos",
      "reviewSummaryFaq": "{{faq}} FAQ propuestas",
      "reviewSummaryPolicies": "{{policies}} políticas propuestas",
      "warningsHeading": "Notas de la importación",
      "reviewEmpty": "Nada nuevo que añadir de este documento.",
      "addSelected": "Añadir seleccionados ({{count}})",
      "back": "Atrás",
      "lowConfidence": "Baja confianza — verifica antes de aplicar",
      "conflictFaq": "FAQ similar existente: {{question}}",
      "conflictPolicy": "Política similar existente: {{title}}",
      "faqCapBanner": "Solo {{allowed}} de {{selected}} FAQ se pueden añadir (máx. 50 por estudio)",
      "successFaq": "Se añadieron {{count}} entradas FAQ",
      "successPolicies": "Se añadieron {{entries}} políticas y {{overrides}} reemplazos",
      "successGeneral": "Se actualizaron {{count}} campos generales",
      "successMixed": "Importación aplicada correctamente",
      "applyPartial": "{{applied}} aplicados. {{failed}} no se pudieron aplicar. Revisa las filas indicadas.",
      "rowApplyFailed": "Esta entrada no se pudo aplicar. Revisa el valor e inténtalo de nuevo.",
      "selectProposal": "Seleccionar propuesta",
      "sourceExcerpt": "Extracto de origen",
      "policyOverrideLabel": "Aplicar como reemplazo de {{section}}",
      "openingHoursStructured": "Se aplicarán horarios estructurados",
      "generalField": {
        "description": "Descripción",
        "address": "Dirección",
        "directions": "Indicaciones",
        "firstVisitInfo": "Info primera visita",
        "facilities": "Instalaciones",
        "openingHours": "Horario de apertura",
        "phone": "Teléfono principal",
        "email": "Correo principal",
        "website": "Sitio web",
        "mapsLink": "Enlace a Google Maps"
      },
      "upload": {
        "dropHint": "Arrastra un archivo aquí o elige uno",
        "chooseFile": "Elegir archivo",
        "removeFile": "Quitar archivo",
        "pasteInstead": "Pegar texto en su lugar",
        "extracting": "Extrayendo texto del archivo…",
        "pdfDisclaimer": "La extracción PDF puede omitir tablas o páginas escaneadas. Revisa las propuestas."
      },
      "errors": {
        "generic": "Error al importar. Inténtalo de nuevo.",
        "PREVIEW_EXPIRED": "La vista previa expiró. Pega el texto de nuevo.",
        "FAQ_LIMIT_REACHED": "Límite de FAQ alcanzado para este estudio.",
        "POLICY_LIMIT_REACHED": "Límite de políticas alcanzado para este estudio.",
        "VALIDATION_ERROR": "Algunas entradas no se pudieron aplicar.",
        "EXTRACTION_FAILED": "No se pudo extraer el contenido.",
        "PREVIEW_TIMEOUT": "El procesamiento tardó demasiado. Prueba un documento más corto.",
        "RATE_LIMITED": "Demasiados intentos. Espera un momento.",
        "RATE_LIMIT_EXCEEDED": "Demasiados intentos. Espera un momento.",
        "KNOWLEDGE_IMPORT_DISABLED": "Importación no disponible temporalmente.",
        "FILE_TOO_LARGE": "Archivo demasiado grande (máx. 5 MB).",
        "UNSUPPORTED_FILE_TYPE": "Tipo de archivo no compatible.",
        "EXTRACTION_EMPTY": "No se extrajo texto de este archivo.",
        "PASSWORD_PROTECTED_FILE": "Este archivo está protegido con contraseña."
      }
    },
    "addNewUnit": "Añadir nuevo estudio",
    "archiveSuccess": "Estudio archivado.",
    "archiveError": "Error al archivar el estudio.",
    "notConfiguredShort": "Conectar",
    "noStudiosFound": "No se han encontrado estudios.",
    "noSearchMatch": "Ningún estudio coincide con tu búsqueda.",
    "backToStudioList": "Volver a la lista del estudio",
    "showStudioList": "Mostrar lista de estudios",
    "expandDetailFullWidth": "Amplía los detalles del estudio a todo el ancho",
    "fullWidthTooltip": "Full width",
    "collapseDetailDefaultWidth": "Volver al ancho predeterminado",
    "moreStudioActionsAria": "Más acciones de estudio",
    "studioIdLabel": "ID del estudio",
    "archiveMenuItem": "Archivo",
    "archiveStudioTitle": "Estudio de archivos",
    "archiveStudioConfirm": "¿Está seguro de querer archivarlo?",
    "dangerZone": "Zona de peligro",
    "archiveStudioDangerBody": "El estudio se moverá a Archivo y se ocultará de las listas de datos de estudio activas.",
    "archiveAnyway": "Archivar de todos modos",
    "sync": {
      "syncAll": "Sincronizar todos los datos",
      "syncPricing": "Sincronizar precios",
      "syncClasses": "Sincronizar clases",
      "syncSchedule": "Sincronizar el horario",
      "syncTeam": "Sincronizar equipo",
      "blockLabel": "Sincronizar {{block}}",
      "syncing": "Sincronizando…",
      "lastSynced": "Última sincronización: {{time}}",
      "error": "Error al sincronizar. Inténtalo de nuevo.",
      "retry": "Reintentar"
    },
    "tabs": {
      "campaigns": {
        "intro": "Cuando alguien te escribe desde uno de tus anuncios de Instagram, el asistente puede dar la bienvenida con la oferta que anunciaba ese anuncio. Configura tus campañas a continuación.",
        "addCampaign": "Añadir campaña",
        "groupCurrent": "Actuales",
        "groupPast": "Campañas pasadas ({{count}})",
        "rowSummary": "{{packs}} paquetes · {{ads}} anuncios",
        "allAdsWord": "todos",
        "statusActiveChip": "Activa · termina el {{date}}",
        "statusEndingSoonChip": "Termina pronto · termina el {{date}}",
        "statusScheduledChip": "Programada · empieza el {{date}}",
        "statusExpiredChip": "Expirada · terminó el {{date}}",
        "statusNotReadyChip": "No lista",
        "versionConflict": "Esta campaña cambió en otra sesión. Revisa la campaña actualizada e inténtalo de nuevo.",
        "readinessTitle": "Preparación",
        "readyChip": "Lista",
        "openAiBehaviour": "Abrir comportamiento de IA",
        "endDateMissingHelper": "¿Cuándo termina esta campaña publicitaria? El asistente deja de dar la bienvenida a nuevos contactos después de esa fecha, para que no tengas que acordarte de desactivarla.",
        "allAdsNote": "Todos los anuncios recibirán esta oferta — elige esta opción solo si todos tus anuncios actuales son sobre ella.",
        "toastCreateFailed": "No se pudo crear la campaña.",
        "toastSaveFailed": "No se pudo guardar.",
        "loadError": "No se pudieron cargar las campañas.",
        "loadErrorRetry": "Reintentar",
        "empty": {
          "title": "Aún no hay campañas",
          "body": "Una campaña agrupa los anuncios, los paquetes de prueba y las fechas de una oferta. Añade una para empezar."
        },
        "missing": {
          "template": "Texto de bienvenida: todavía no configurado por OktoGo",
          "packs": "Añade al menos un paquete",
          "pack_link": "A un paquete le falta un enlace de compra",
          "eligible_ads": "Elige qué anuncios llevan aquí",
          "valid_to": "Falta la fecha de fin",
          "ad_conflict": "Conflicto de anuncio"
        },
        "welcomeMessage": {
          "title": "Mensaje de bienvenida",
          "hint": "Un único mensaje de bienvenida para todas las campañas · el primer mensaje que recibe un nuevo lead, con los paquetes de esta campaña",
          "placeholder": "Escribe el mensaje que recibe primero un nuevo lead…",
          "tabEdit": "Editar",
          "tabPreview": "Vista previa",
          "tokenHint": "Mantén {{packs}} en el texto — se reemplaza con los paquetes de esta campaña.",
          "counter": "{{current}} / {{max}}",
          "errorEmpty": "El mensaje de bienvenida no puede estar vacío.",
          "errorMissingSlot": "Añade {{packs}} donde deban aparecer los paquetes de la campaña.",
          "versionConflict": "Este mensaje de bienvenida cambió en otra sesión. Recarga antes de guardar.",
          "translationFailed": "No se pudo traducir este mensaje de bienvenida a los demás idiomas, así que esta versión todavía no está en uso. Edita el texto y guárdalo de nuevo para volver a intentarlo."
        },
        "addDialog": {
          "title": "Añadir campaña",
          "nameLabel": "Nombre de la campaña",
          "namePlaceholder": "p. ej. Oferta de prueba de otoño",
          "validFromLabel": "Empieza",
          "validToLabel": "Termina",
          "allAdsCheckbox": "Todos mis anuncios de Instagram",
          "create": "Crear campaña",
          "nameRequired": "El nombre de la campaña es obligatorio.",
          "dateRangeInvalid": "La fecha de fin no puede ser anterior a la fecha de inicio."
        },
        "packsCard": {
          "title": "Paquetes de prueba ofrecidos a los contactos de la campaña",
          "addPack": "Añadir paquete",
          "empty": "Aún no hay paquetes. Añade uno para ofrecer una prueba a los contactos de la campaña.",
          "shopWide": "paquete general de la tienda",
          "linkFromEversports": "enlace de Eversports",
          "linkPasted": "enlace pegado",
          "noLinkYet": "la clase aún no tiene enlace de página",
          "priceDrift": "el precio cambió en Eversports"
        },
        "packPanel": {
          "titleNew": "Nuevo paquete",
          "nameLabel": "Nombre del paquete",
          "namePlaceholder": "p. ej. Paquete de prueba 2+1 20 min",
          "nameRequired": "El nombre del paquete es obligatorio.",
          "priceLabel": "Precio",
          "currencyLabel": "Moneda",
          "conditionsLabel": "Condiciones (opcional)",
          "conditionsPlaceholder": "p. ej. 3 clases guiadas de baño de hielo de 20 minutos en 3 meses",
          "linkedClassSectionTitle": "Clase vinculada",
          "pricingOptionsTitle": "Opciones de precio (esta clase, de Eversports)",
          "pricingOptionsEmpty": "Todavía no hay opciones de precio sincronizadas para esta clase.",
          "purchaseLinkLabel": "Enlace de compra",
          "purchaseLinkPlaceholder": "https://www.eversports.at/e/…",
          "fromEversports": "de Eversports",
          "pasteALink": "Pegar un enlace",
          "syncClassesAndPricing": "Sincronizar clases y precios",
          "readinessMissingLink": "⚠ Esta clase aún no tiene enlace de página.",
          "linkHostWarning": "Esto no parece un enlace de Eversports. Los paquetes de campaña suelen venderse en tu página de Precios de Eversports.",
          "priceDriftWarning": "El precio del paquete cambió en Eversports — revisar (sincronizado {{synced}})",
          "deleteTitle": "¿Eliminar el paquete?",
          "deleteDescription": "Esta acción no se puede deshacer.",
          "delete": "Eliminar"
        },
        "classPicker": {
          "linkToClass": "Vincular a una clase",
          "shopWidePack": "Paquete general de la tienda — sin una clase concreta",
          "searchPlaceholder": "Busca entre tus clases…",
          "loading": "Cargando tus clases…",
          "noMatch": "Ninguna clase coincide.",
          "addManually": "¿No la encuentras? → Añade la clase manualmente",
          "hasPage": "● página",
          "noPage": "○ sin página",
          "changeClass": "Cambiar clase",
          "manualNote": "introducido manualmente — no sincronizado",
          "manual": {
            "nameLabel": "Nombre de la clase",
            "namePlaceholder": "p. ej. Pure Ice Bath",
            "linkLabel": "Enlace de la clase (página de la clase en Eversports)",
            "linkPlaceholder": "https://www.eversports.at/e/…",
            "helper": "Abre la clase en Eversports y pega la dirección de su página (…/e/… o …/activity/…)."
          }
        },
        "adsCard": {
          "title": "Qué anuncios llevan aquí",
          "radioListed": "Solo los anuncios que liste a continuación",
          "radioAll": "Todos mis anuncios de Instagram",
          "addAd": "Añadir anuncio",
          "adIdLabel": "ID del anuncio de Meta",
          "adIdHelpAria": "¿Qué es el ID del anuncio de Meta?",
          "adIdTooltipWhy": "Así reconocemos a las personas que llegan desde este anuncio, para que reciban el mensaje de bienvenida de esta campaña.",
          "adIdTooltipWhere": "Copia el ID del anuncio desde la columna «ID del anuncio» en el Administrador de anuncios de Meta — o pega directamente el enlace del Administrador de anuncios del anuncio en este campo.",
          "adIdPlaceholder": "p. ej. 120212345678901234",
          "labelOptional": "Etiqueta (opcional)",
          "labelPlaceholder": "p. ej. Anuncio de prueba de verano",
          "empty": "Aún no hay anuncios listados.",
          "delete": "Quitar anuncio",
          "edit": "Editar anuncio",
          "formatError": "Indica el número del anuncio, o pega el enlace del Administrador de anuncios de Meta del anuncio.",
          "campaignLinkError": "Ese enlace apunta a una campaña, no a un anuncio concreto. Abre el anuncio en el Administrador de anuncios y pega ese enlace.",
          "adsetLinkError": "Ese enlace apunta a un conjunto de anuncios, no a un anuncio concreto. Abre el anuncio en el Administrador de anuncios y pega ese enlace.",
          "multipleAdsError": "Ese enlace contiene más de un anuncio. Añade los anuncios de uno en uno.",
          "duplicateError": "Este ID de anuncio ya está en la lista.",
          "conflictError": "Ya usado por «{{name}}» (hasta el {{date}}).",
          "conflictErrorOpenEnded": "Este anuncio está reservado por «{{name}}» sin fecha de fin. Establece una fecha de fin para la campaña que lo reserva.",
          "wildcardConflictErrorOpenEnded": "Todos los anuncios están reservados por «{{name}}» sin fecha de fin. Establece una fecha de fin para la campaña que los reserva.",
          "wildcardConflictError": "«{{name}}» ya reclama todos los anuncios en un período que se solapa (hasta el {{date}}).",
          "helperTitle": "¿Cómo encuentro el ID del anuncio de Meta?",
          "helperStep1": "Abre el Administrador de anuncios de Meta → pestaña Anuncios.",
          "helperStep2": "Añade la columna «ID del anuncio» (Columnas → Personalizar) — o abre el anuncio y pega aquí su dirección completa; encontraremos el número después de «selected_ad_ids=».",
          "helperStep3": "Pega aquí el número — o pega el enlace del Administrador de anuncios del anuncio y encontraremos el número.",
          "learnMore": "Más información",
          "notSureHint": "¿No estás seguro? Elige «Todos mis anuncios de Instagram» por ahora — podrás acotarlo más adelante."
        }
      },
      "faq": {
        "saving": "Guardando…",
        "saved": "Guardado",
        "addFaq": "Añadir FAQ",
        "readOnly": "Solo lectura",
        "questionPlaceholder": "Pregunta",
        "answerPlaceholder": "Respuesta",
        "deleteTitle": "<a href=“%s”>Borrar FAQ</a>",
        "deleteDescription": "Esta acción no se puede revertir.",
        "delete": "Eliminar",
        "empty": "Aún no hay preguntas frecuentes. Añade la primera arriba.",
        "toastAdded": "Preguntas frecuentes añadidas.",
        "toastAddFailed": "Error al agregar.",
        "toastUpdated": "FAQ Actualizado",
        "toastUpdateFailed": "No se ha podido actualizar.",
        "toastDeleted": "Preguntas frecuentes eliminadas.",
        "toastDeleteFailed": "XXX"
      },
      "general": {
        "openingHours": "HORARIOS",
        "closed": "Cerrado",
        "location": "Ubicación",
        "description": "Descripción",
        "descriptionPlaceholder": "Breve resumen para clientes y la IA—qué ofreces, ambiente y detalles prácticos como aparcamiento.",
        "address": "Dirección",
        "addressPlaceholder": "ej. Calle Mayor 42, 28013 Madrid",
        "addressInvalid": "Introduce una dirección con letras, un número y un espacio o una coma.",
        "timezone": "Zona horaria del estudio",
        "timezonePlaceholder": "ej. Europe/Madrid",
        "timezoneHelper": "Se usa para los horarios y las acciones sensibles al tiempo de este estudio.",
        "timezoneInvalid": "Introduce una zona horaria IANA válida, por ejemplo Europe/Madrid.",
        "hoursRequired": "Indica una hora de apertura y de cierre para {{day}}, o marca el día como cerrado.",
        "hoursOutOfOrder": "La hora de cierre de {{day}} debe ser posterior a la hora de apertura.",
        "mapsLink": "Vínculo al Mapa de Google",
        "mapsLinkPlaceholder": "https://maps.google.com/…",
        "mapsLinkInvalid": "Introduce un enlace de Google Maps.",
        "directions": "Direcciones",
        "directionsPlaceholder": "Cómo llegar—entrada, planta, transporte, aparcamiento u otros consejos de llegada.",
        "contacts": "Contacto",
        "phone": "Teléfono principal",
        "phonePlaceholder": "+34 91 123 45 67",
        "phoneInvalid": "Introduce un teléfono con al menos 6 dígitos. Solo dígitos y puntuación habitual.",
        "email": "Correo principal",
        "emailPlaceholder": "hola@tuestudio.es",
        "emailInvalid": "Introduce una dirección de correo válida.",
        "website": "Sitio web",
        "websitePlaceholder": "tuestudio.es",
        "facilities": "Instalaciones",
        "facilityPlaceholder": "Agregar servicio",
        "add": "Añadir",
        "firstVisit": "Primera visita",
        "firstVisitLinks": {
          "trialRegistrationLabel": "Enlace de registro de prueba (Escenario 1)",
          "trialRegistrationPlaceholder": "tuestudio.es/registro-prueba",
          "trialRegistrationHelper": "Se usa cuando el cliente todavía no tiene cuenta en la plataforma de reservas.",
          "studioLabel": "Página de Eversports del estudio (Escenario 2)",
          "studioPlaceholder": "www.eversports.com/s/tu-estudio",
          "studioHelper": "Se usa cuando el cliente tiene una cuenta de Eversports pero es nuevo en tu estudio. Para info general prefiere Overview abajo.",
          "overviewLabel": "Página Resumen",
          "overviewPlaceholder": "www.eversports.com/s/tu-estudio",
          "overviewHelper": "Sección pública Resumen (sobre nosotros, dirección, instalaciones). Para preguntas generales del estudio.",
          "classesLabel": "Calendario de clases",
          "classesPlaceholder": "www.eversports.com/scl/tu-estudio",
          "classesHelper": "Calendario semanal público. Cuando preguntan qué hay o cómo reservar.",
          "pricesLabel": "Página de precios",
          "pricesPlaceholder": "www.eversports.com/sp/tu-estudio",
          "pricesHelper": "Catálogo público de precios / productos. Para membresías y precios de productos.",
          "urlInvalid": "Añade la dirección del sitio web, por ejemplo rowinc.studio."
        },
        "firstVisitPlaceholder": "Qué deben saber los nuevos clientes antes de la primera visita—llegada, qué llevar, registro y normas del estudio.",
        "saveChanges": "Guardar cambios",
        "toastSaved": "Cambios guardados.",
        "toastSaveFailed": "No se pudo guardar.",
        "weekday": {
          "monday": "Lunes",
          "tuesday": "Martes",
          "wednesday": "Miércoles",
          "thursday": "Jueves",
          "friday": "Viernes",
          "saturday": "Sábado",
          "sunday": "Domingo"
        }
      },
      "generalPublic": {
        "heading": "Info pública del estudio",
        "syncLabel": "Sincronizar General",
        "syncCaption": "Sincronizar General actualiza juntos tu «Acerca de» público, las comodidades, Instagram y la valoración.",
        "previewCaption": "Datos de vista previa — no son datos reales sincronizados del estudio",
        "empty": "Aún no sincronizado. Haz clic en «Sincronizar General» para previsualizar info pública de ejemplo.",
        "aboutHeading": "Acerca de",
        "amenitiesHeading": "Comodidades",
        "amenityOffered": "Disponible",
        "amenityNotOffered": "No disponible",
        "amenityUnknown": "Aún no sincronizado",
        "ratingLabel": "{{value}} ({{count}} reseñas)"
      },
      "policies": {
        "toastSaved": "Anulación de política guardada.",
        "toastSaveFailed": "No se pudo guardar.",
        "toastAdded": "Política añadida.",
        "toastAddFailed": "No se pudo añadir la política.",
        "toastUpdated": "Política actualizada.",
        "toastUpdateFailed": "No se pudo actualizar la política.",
        "toastDeleted": "Política eliminada.",
        "toastDeleteFailed": "No se pudo eliminar la política.",
        "syncedFrom": "Sincronizado desde {{source}}",
        "bookingPlatformFallback": "Una plataforma para hacer reservas",
        "manualEntriesTitle": "Políticas personalizadas",
        "addPolicy": "Añadir política",
        "policyTitlePlaceholder": "Título de la política",
        "policyContentPlaceholder": "Introduce los detalles de la política…",
        "manualEntriesEmpty": "Aún no hay políticas personalizadas.",
        "deleteTitle": "¿Eliminar política?",
        "deleteDescription": "Esta entrada de política se eliminará.",
        "delete": "Eliminar",
        "ownerOverride": "Anulación del propietario",
        "overridePlaceholder": "Introduzca el texto de su propia política para anular la versión sincronizada...",
        "saveOverride": "Guardar anulación",
        "overrideActive": "Anulación de propietario (activo)",
        "refundIfCancelledAtLeast": "Reembolso si se cancela al menos",
        "beforeClassStart": "antes del inicio de la clase",
        "hoursBeforeClassStart": "horas antes del inicio de la clase",
        "hoursPreset": "{{count}} horas",
        "hoursCustom": "Personalizado…",
        "toastInvalidHours": "Introduce un número entero de horas entre 1 y 168.",
        "customHoursAria": "Horas personalizadas",
        "hoursInfoAria": "Más sobre esta regla",
        "hoursInfoTitle": "Sobre este número",
        "hoursInfoCredit": "Crédito de clase o bono devuelto — no un reembolso bancario.",
        "hoursInfoMove": "Las mismas horas si piden mover esa clase.",
        "hoursInfoNumberBeatsNotes": "Copilot sigue este número, no las notas de abajo.",
        "hoursPreview": "Los clientes que cancelen {{hours}} horas o más antes del inicio de la clase pueden recuperar un crédito de clase o el bono. Más tarde: aún pueden cancelar o mover, sin crédito.",
        "additionalNotes": "Notas adicionales de cancelación (opcional)",
        "additionalNotesHint": "Excepciones, enfermedad, preaviso de abono — Copilot puede explicarlas. No cambian las horas de arriba.",
        "additionalNotesPlaceholder": "Introduce notas extra de la política…",
        "saveAdditionalNotes": "Guardar",
        "additionalNotesActive": "Notas adicionales",
        "empty": "Aún no hay secciones de políticas. Conecta una plataforma de reservas para sincronizar el texto de las políticas.",
        "syncCancellationPolicy": "Sincronizar política de cancelación",
        "syncRefundPolicy": "Sincronizar política de reembolso",
        "cancellationPolicyEmpty": "Aún no publicado públicamente — nada inventado. Haz clic en \"Sincronizar política de cancelación\" para comprobar de nuevo.",
        "refundPolicyEmpty": "Aún no publicado públicamente — nada inventado. Haz clic en \"Sincronizar política de reembolso\" para comprobar de nuevo.",
        "refundPolicyPreviewLine": "Datos de vista previa — no es texto de política importado real: \"Reembolso completo hasta 24 horas antes del inicio de la clase; crédito de clase después de eso.\""
      },
      "prices": {
        "syncCaption": "Sincronizar precios actualiza esta pestaña y las opciones de precio de cada clase a la vez.",
        "previewCaption": "Datos de vista previa — no son precios en vivo de Eversports",
        "membershipsHeading": "Membresías",
        "membershipsEmpty": "Aún no sincronizado. Haz clic en \"Sincronizar precios\" para previsualizar membresías de muestra.",
        "productsHeading": "Productos",
        "productsEmpty": "Aún no sincronizado. Haz clic en \"Sincronizar precios\" para previsualizar productos de muestra.",
        "minRuntime_one": "{{count}} mes mínimo",
        "minRuntime_other": "{{count}} meses mínimo"
      },
      "team": {
        "syncCaption": "Sincronizar equipo actualiza esta pestaña con el directorio de instructores de tu página pública de Eversports.",
        "previewCaption": "Datos de vista previa — no es un directorio real de instructores",
        "heading": "Instructores",
        "empty": "Aún no sincronizado. Haz clic en \"Sincronizar equipo\" para previsualizar instructores de muestra.",
        "viewSchedule": "Ver horario"
      },
      "users": {
        "selectStudio": "Selecciona un estudio para gestionar a los usuarios.",
        "peopleWithAccessLead": "Personas con acceso a",
        "peopleWithAccessTrail": ".",
        "thisStudio": "este estudio",
        "addMember": "Añadir miembro",
        "inviteTitle": "Invitar a un miembro del equipo",
        "email": "Correo electrónico",
        "managerInviteShort": "Los gerentes solo pueden invitar al personal.",
        "sendInvitation": "Enviar invitación",
        "revokeHintAddMember": "Puedes enviar una nueva invitación más tarde desde «Añadir miembro» si cambias de idea.",
        "emptyTeam": "Aún no hay miembros del equipo ni invitaciones pendientes."
      },
      "sidePanel": {
        "title": "Añadir estudio",
        "studioName": "Nombre del estudio",
        "namePlaceholder": "Introduce el nombre del estudio",
        "nameRequired": "El nombre del estudio es obligatorio.",
        "nameTooShort": "El nombre del estudio debe tener al menos 2 caracteres.",
        "nameTooLong": "El nombre del estudio debe tener como máximo 60 caracteres.",
        "nameAlreadyExists": "El nombre del estudio ya existe.",
        "nameArchivedConflict": "Este nombre coincide con un estudio archivado. Restaura o renombra primero el estudio archivado.",
        "studioLimitReached": "Máximo 5 estudios activos. Archiva un estudio antes de crear otro.",
        "description": "Descripción",
        "descriptionPlaceholder": "Introduce la descripción del estudio",
        "descriptionTooLong": "La descripción debe tener como máximo 200 caracteres.",
        "descriptionCharCount": "{{current}}/{{max}}",
        "teamMembers": "Miembros del equipo",
        "teamHint": "Invita a personas después de crear el estudio, o añade nombres y correos abajo para invitar automáticamente.",
        "memberNamePlaceholder": "Nombre completo",
        "memberNameRequired": "El nombre es obligatorio.",
        "memberNameAria": "Nombre del invitado",
        "memberEmailAria": "Correo del invitado",
        "emailPlaceholder": "correo@ejemplo.com",
        "emailRequired": "El correo es obligatorio.",
        "emailInvalid": "Introduce una dirección de correo válida.",
        "emailDuplicate": "Ese correo ya está en la lista.",
        "addMemberButtonAria": "Añadir miembro del equipo a la lista",
        "editMemberAria": "Editar miembro del equipo",
        "saveMemberEdit": "Guardar miembro",
        "finishEditingFirst": "Guarda o cancela los cambios antes de crear el estudio.",
        "removeAria": "Quitar",
        "cancel": "Cancelar",
        "create": "Crear estudio",
        "toastInvalidEmail": "Introduce un correo electrónico válido.",
        "toastDuplicateEmail": "Ese correo ya está en la lista.",
        "toastCreateFailed": "No se pudo crear el estudio.",
        "toastInviteFailed": "No se pudo enviar la invitación a {{email}}.",
        "toastCreated": "Estudio creado.",
        "toastGrantFailedExisting": "No se pudo conceder acceso a {{email}} en este estudio.",
        "toastGrantAlreadyMemberExisting": "{{email}} ya es miembro de este nuevo estudio."
      },
      "trace": {
        "panelTitle": "Traza del agente de visión",
        "closeAria": "Cerrar",
        "enterFullscreenAria": "Expandir a pantalla completa",
        "exitFullscreenAria": "Salir de pantalla completa",
        "backToClasses": "Volver a clases",
        "pageTitle": "Traza del agente de visión",
        "pageSubtitle": "Elige una ejecución reciente de la lista (auditoría ClickHouse) o pega un ID de ejecución. S3 es necesario para capturas y descargas de artefactos.",
        "selectStudioForTraces": "Selecciona un estudio para cargar trazas.",
        "recentRuns": "Ejecuciones recientes del agente",
        "window": "Ventana",
        "daysOption": "{{count}} días",
        "refresh": "Actualizar",
        "clickHouseNoList": "No hay ejecuciones del agente en este periodo. La auditoría ClickHouse no está configurada; esta lista proviene del registro de auditoría Postgres local. Usa «ID de ejecución» abajo si tienes un UUID.",
        "loadingRuns": "Cargando ejecuciones…",
        "lastActivity": "Última actividad",
        "platform": "Plataforma",
        "lastEvent": "Último evento",
        "events": "Eventos",
        "estimatedLlmCostColumn": "Coste LLM estimado",
        "runsListTotalEstimatedLlmCost": "Total de ejecuciones mostradas (LLM estimado): {{amount}}",
        "runsListCostDisclaimer": "Los importes son estimaciones en la app según el uso de tokens (heurísticas de precio de lista), no facturas.",
        "runIdLabel": "ID de ejecución (opcional)",
        "runIdSrOnly": "ID de ejecución del agente",
        "runIdPlaceholder": "Pega el UUID si no está en la lista de arriba",
        "loadTrace": "Cargar traza",
        "loadError": "No se pudo cargar la traza.",
        "syncComplete": "Sincronización completada",
        "syncFailed": "Error de sincronización",
        "runLoaded": "Ejecución cargada",
        "linkPlaywrightTrace": "Traza Playwright",
        "linkRecording": "Grabación",
        "linkHar": "HAR",
        "linkLlmDecisions": "Decisiones del LLM",
        "latestStepAlt": "Último paso",
        "classesSynced": "{{count}} clases sincronizadas",
        "percentComplete": "100 %",
        "llmTotalLabel": "Total LLM:",
        "llmCallsCount": "({{count}} llamadas)",
        "failureHeading": "Captura de error",
        "failureAlt": "Error",
        "s3NotConfigured": "Las trazas de agente en S3 no están configuradas en este servidor; capturas y descargas no disponibles.",
        "durationMs": "{{n}} ms",
        "durationSeconds": "{{n}} s",
        "runDurationSuffix": " · {{n}} s",
        "tokensSummary": "{{input}} entrada / {{output}} salida ({{total}} tokens)",
        "orchestratorTraceHeading": "Traza del orquestador de chat",
        "intent": "Intención",
        "confidence": "Confianza",
        "decisionOrigin": "Decisión",
        "groundingVerdict": "Fundamentación",
        "escalationReason": "Escalada",
        "toolsCalled": "Herramientas",
        "toolOutcome": "Resultado de la herramienta",
        "ragChunks": "RAG",
        "decisionSteps": "Pasos de decisión",
        "llmTemperature": "temp {{value}}",
        "llmMaxTokens": "máx {{value}} tokens",
        "expandDetails": "Detalles",
        "collapseDetails": "Ocultar",
        "executionRoute": "Ruta",
        "interactionMode": "Modo",
        "subFlow": "Subflujo",
        "method": "Método",
        "selfHealed": "Autocorregido",
        "systemPrompt": "Sistema",
        "userPrompt": "Usuario",
        "llmResponse": "Respuesta",
        "llmPromptKey": "Prompt",
        "llmPromptSummary": "Estructura",
        "llmReasoning": "Razonamiento",
        "promptKind": "Tipo",
        "workflowLiveBadge": "En vivo",
        "workflowReplayBadge": "Reproducción",
        "workflowTopologyTitle": "Topología del flujo",
        "workflowEventsCount": "{{count}} eventos en vivo",
        "cascadeOf": "Cascada del fallo raíz {{rootCauseId}}",
        "technicalDetails": "Detalles técnicos",
        "openConversation": "Abrir la conversación",
        "privacyHiddenContent": "(contenido oculto por privacidad)",
        "tier": {
          "decisionLabel": "Decisión de nivel",
          "name": {
            "json_feed": "Feed JSON",
            "dom_text_early": "Texto DOM (temprano)",
            "dom_script": "Script DOM",
            "cli_playwright": "CLI Playwright",
            "mcp_text": "Texto MCP",
            "vision_agent": "Agente vision"
          },
          "outcome": {
            "success": "Éxito",
            "fail": "Fallo",
            "skip": "Omitido"
          },
          "reason": {
            "skip_anonymous_or_non_schedule": "Omitido (anónimo / fuera de horario)",
            "skip_dom_not_applicable": "Omitido (DOM no aplicable)",
            "disabled_by_config": "Deshabilitado por configuración",
            "consecutive_failures": "Fallos consecutivos",
            "llm_last_resort_enabled": "LLM como último recurso activo",
            "range_mismatch": "Rango de fechas no coincide",
            "empty_feed": "Feed vacío",
            "tier_timeout": "Tiempo de espera del nivel agotado",
            "tier_error": "Error de nivel",
            "selector_not_found": "Selector no encontrado",
            "initial_navigation_failed": "Navegación inicial fallida",
            "auth_retry_limit": "Límite de reintentos de autenticación alcanzado",
            "reauth_failed": "Reautenticación fallida",
            "no_meaningful_result": "Sin resultado significativo"
          }
        }
      },
      "classes": {
        "weekdayMon": "lun",
        "weekdayTue": "mar",
        "weekdayWed": "mié",
        "weekdayThu": "jue",
        "weekdayFri": "vie",
        "weekdaySat": "sáb",
        "weekdaySun": "dom",
        "viewList": "Lista",
        "viewCalendar": "Calendario",
        "syncComplete": "Sincronización completada",
        "syncFailed": "Error de sincronización",
        "syncing": "Sincronizando…",
        "viewTrace": "Ver traza",
        "latestStepAlt": "Último paso",
        "agentScreenshots": "Capturas del agente ({{count}})",
        "stepLabel": "Paso {{n}}",
        "tableClass": "Clase",
        "tableInstructor": "Instructor",
        "tableTime": "Hora",
        "tableDuration": "Duración",
        "tableLevel": "Nivel",
        "tableSpots": "Plazas en la próxima clase",
        "minutes": "{{n}} min",
        "spotsLeft": "{{n}} libres",
        "full": "Completo",
        "emptyList": "Aún no hay clases sincronizadas. Conecta una plataforma de reservas y ejecuta una sincronización.",
        "detailStudio": "Studio",
        "detailLocation": "Ubicación",
        "detailTrainer": "Instructor",
        "detailTime": "Hora",
        "detailCapacity": "Aforo",
        "detailDuration": "Duración",
        "about": "Acerca de",
        "descriptionEmpty": "Aún no hay descripción de la clase sincronizada.",
        "pricingOptions": "Opciones reservables de esta clase",
        "pricingOptionsEmpty": "Opciones de precio aún no disponibles. Copilot no inventará precios.",
        "links": "Enlaces",
        "classPageLink": "Abrir página de la clase",
        "bookingLink": "Abrir enlace de reserva",
        "bookSlot": "Reservar",
        "clients": "Clientes ({{count}})",
        "bookingConfirmed": "Confirmada",
        "bookingWaitlisted": "Lista de espera",
        "bookingCancelled": "Cancelada",
        "bookingCheckedIn": "Check-in hecho",
        "upcomingSchedule": "Próximas sesiones",
        "noUpcomingSessions": "No hay sesiones próximas en este periodo.",
        "showNextMonth": "Ver mes siguiente",
        "showNextMonthAria": "Mostrar mes siguiente",
        "loading": "Cargando…",
        "toastSyncComplete": "Sincronización completada correctamente.",
        "toastSyncFailed": "Error en la sincronización.",
        "toastSyncBookingPlatformNotConfigured": "Conecta una plataforma de reservas (Eversports, Mindbody o Bsport) antes de sincronizar.",
        "syncLogInit": "Iniciando sincronización para {{start}} → {{end}}…",
        "syncLogStarted": "Trabajo de sincronización iniciado en el servidor",
        "syncLogScreenshots": "Cargadas {{count}} capturas del agente",
        "syncLogCompleted": "Sincronización completada",
        "syncLogFailedMsg": "Error en la sincronización",
        "syncStartError": "No se pudo iniciar la sincronización"
      }
    }
  },
  "studioDataFilter": {
    "filter": "Filtro",
    "clearAll": "Borrar todo",
    "panelTitle": "Filtro",
    "panelDescription": "Narrow the studio list by integrations, booking source, and location.",
    "closeSheetAria": "Cerrar",
    "sheetAriaLabel": "Filter studios",
    "channelConnection": "{{channel}} — connection",
    "sectionBookingSource": "Booking source",
    "sectionLocation": "Location (city, country)",
    "channelInstagram": "Instagram",
    "channelWhatsapp": "WhatsApp",
    "channelBooking": "Reserva",
    "tagChannelStatus": "{{channel}}: {{status}}",
    "tagSource": "Source: {{source}}",
    "connectionStatus": {
      "connected": "Connected",
      "error": "Error",
      "not_connected": "Not connected"
    },
    "bookingSource": {
      "eversports": "Eversports",
      "mindbody": "Mindbody",
      "bsport": "Bsport",
      "none": "None",
      "other": "Otros"
    }
  },
  "team": {
    "selectStudioHint": "Select a studio in the header switcher to view the team list, remove members, and use Invite again for pending invites.",
    "aggregateListHint": "Los miembros del equipo y las invitaciones pendientes se muestran para cada estudio al que tienes acceso. Quitar y reenviar aplican al estudio de cada fila.",
    "inviteMember": "Invite Team Member",
    "studiosMultiLabel": "Studios (select one or more)",
    "studioSingleLabel": "Studio",
    "noStudiosForInvite": "No studios are available for invitations with your account.",
    "includeStudioAria": "Include {{name}}",
    "emailAddress": "Email address",
    "inviteNamePlaceholder": "Introduce el nombre",
    "emailPlaceholder": "team@studio.com",
    "role": "Role",
    "roleManager": "Manager",
    "roleStaff": "Staff",
    "managerInviteHint": "Managers can invite Staff only (per studio access you manage).",
    "accessPreview": "They will get access to {{studios}} as {{role}}.",
    "roleOwner": "Owner",
    "sendInvitation": "Send Invitation",
    "colName": "Name",
    "pendingInviteNoName": "—",
    "pendingInviteNameSr": "Invitación pendiente para {{email}}",
    "emailInvalid": "Introduce una dirección de correo válida.",
    "colStudio": "Estudio",
    "colEmail": "Correo Electrónico",
    "colRole": "Role",
    "colStatus": "Sincronizar el estado de confirmación de la reserva con el pedido Woo correspondiente",
    "colActions": "Actions",
    "statusActive": "Active",
    "statusPending": "Pending",
    "ownerCannotRemove": "Studio owners cannot be removed here",
    "inviteAgain": "Invite again",
    "inviteToOtherStudios": "Invitar a otros estudios",
    "editAccess": "Editar acceso",
    "editAccessLoadingStudios": "Cargando estudios donde este miembro tiene acceso…",
    "editAccessPerStudioHint": "Elige un rol para cada estudio. Solo se listan los estudios que puedes administrar.",
    "editAccessNothingChanged": "No hay cambios que guardar.",
    "editAccessStudioRoleAria": "{{studio}} — rol",
    "editAccessMemberDetail": "{{name}} · {{email}}",
    "removeMemberMultiHint": "Elige cada estudio del que quieras quitar a esta persona. Los no marcados mantienen el acceso.",
    "removeMemberLoadingScope": "Comprobando estudios…",
    "removeMemberStudioToggleAria": "Quitar de {{name}}",
    "removeMemberPickOneStudio": "Selecciona al menos un estudio.",
    "toastMemberRemovedMulti": "Quitado de {{count}} estudios.",
    "toastRemovePartialFail": "No se pudo quitar de: {{studios}}. Inténtalo de nuevo en esos estudios.",
    "resendInvitation": "Reenviar invitación",
    "editPendingInviteAria": "Editar invitación pendiente para {{email}}",
    "editPendingInviteTitle": "Editar invitación pendiente",
    "editPendingInviteSave": "Guardar cambios",
    "toastInviteUpdated": "Invitación actualizada.",
    "toastAccessUpdated": "Acceso del miembro actualizado.",
    "toastEditAccessPartialFail": "No se pudo actualizar el acceso para: {{studios}}. Inténtalo de nuevo en esos estudios.",
    "toastInviteUpdatePartial": "Invitación anterior revocada, pero falló el reenvío. Usa «Añadir miembro» para invitar de nuevo.",
    "removeMemberAria": "Remove {{name}} from studio",
    "revokeInviteAria": "Revoke invitation",
    "removeMemberTitle": "Remove team member",
    "removeMemberBody": "Are you sure you want to remove this person from the studio?",
    "removeMemberDetail": "{{name}} ({{email}}) will lose access to this studio immediately.",
    "removeMemberDetailStudio": "{{name}} ({{email}}) perderá el acceso a {{studio}} de inmediato.",
    "dangerIrreversible": "This action is irreversible from here. Their OktoGo account is not deleted; you can invite them again later if needed.",
    "removeAnyway": "Remove anyway",
    "revokeTitle": "Revoke invitation",
    "revokeBody": "The pending invite to {{email}} will be cancelled. They will not be able to join with the current link.",
    "revokeHint": "You can send a new invitation later from Invite Team Member if you change your mind.",
    "revoke": "Revoke",
    "toastInviteSent": "Invitation sent.",
    "toastInviteFailed": "Failed to send invitation.",
    "toastAlreadyMember": "{{email}} ya es miembro de este estudio. Abre la lista del equipo a continuación para gestionar su rol.",
    "toastAlreadyMemberMulti": "{{email}} ya es miembro de uno de los estudios seleccionados. Desmárcalo e inténtalo de nuevo.",
    "addMemberSearchPlaceholder": "Añadir por nombre o correo",
    "addMemberSearchHint": "Elige a alguien de tus estudios o escribe un nuevo correo para invitarlo.",
    "candidateSearching": "Buscando…",
    "candidateNoMatches": "No hay compañeros que coincidan en tus estudios.",
    "candidateNoMatchHelp": "Aún no reconocemos este correo — enviaremos una invitación.",
    "candidateAlreadyMemberBadge": "Ya es miembro",
    "candidateChange": "Cambiar",
    "candidateAlreadyInLabel": "Ya en: {{studios}}",
    "refineSearch": "Refina tu búsqueda.",
    "candidateAlreadyMemberHere": "{{name}} ya es miembro de este estudio.",
    "grantAccessTitle": "Conceder acceso",
    "grantAccessButton": "Conceder acceso",
    "grantAccessNotice": "{{name}} verá este acceso la próxima vez que abra OktoGo.",
    "toastGrantSuccess": "Acceso concedido a {{name}}.",
    "toastGrantFailed": "No se pudo conceder el acceso.",
    "toastMemberRemoved": "Member removed from this studio.",
    "toastRemoveFailed": "Failed to remove member.",
    "toastResent": "Invitation sent again.",
    "toastResendFailed": "Failed to resend.",
    "toastResendRateLimited": "La invitación se acaba de reenviar. Inténtalo de nuevo en unos minutos.",
    "toastRevoked": "Invitation revoked.",
    "toastRevokeFailed": "Failed to revoke.",
    "candidateSelectBeforeInvite": "{{email}} ya pertenece a un usuario existente. Selecciona ese usuario de la lista para conceder acceso."
  },
  "connections": {
    "addChannel": "Add Channel",
    "addBookingPlatform": "Añadir plataforma de reservas",
    "mockModeBanner": "Modo simulación — los canales son simulados, sin conexiones reales con Meta ni plataformas de reserva.",
    "mockReconnectHint": "En modo simulación: usa Reconectar para actualizar el estado simulado de WhatsApp.",
    "errors": {
      "connectionIssue": "Problema de conexión",
      "activationRequired": "Activación de WhatsApp requerida — introduce tu PIN de 6 dígitos en Ajustes"
    },
    "colChannel": "Channel",
    "colIdentifier": "Identifier",
    "colAppliesTo": "Se aplica a",
    "colStatus": "Sincronizar el estado de confirmación de la reserva con el pedido Woo correspondiente",
    "colActions": "Actions",
    "statusConnected": "Connected",
    "statusError": "Error",
    "statusSkipped": "Skipped",
    "statusNotConnected": "Not connected",
    "connectedSince": "Connected since {{date}}",
    "connectedSinceLabel": "Conectado desde",
    "lastSynced": "Last synced: {{time}}",
    "configure2fa": "Configure 2FA",
    "reconnect": "Reconnect",
    "connect": "Conectar",
    "emptyChannels": "No channels configured. Add one to get started.",
    "modalAddTitle": "Add Channel",
    "channelType": "Channel Type",
    "addChannelTenantScopeHint": "Los canales de mensajería se aplican a todos los estudios de tu cuenta. No estás asignando un canal a un solo estudio.",
    "addChannelSubmit": "Add Channel",
    "bookingReconnectTitle": "Reconnect Booking Platform",
    "bookingConnectTitle": "Connect Booking Platform",
    "bookingTenantScopeHint": "Las credenciales de la plataforma de reservas se aplican a todos los estudios de tu cuenta. No estás limitando esta integración a un solo estudio.",
    "twoFaTenantScopeHint": "La autenticación en dos pasos para reservas aplica a nivel de cuenta en Eversports y cubre todos los estudios que usan esta conexión.",
    "platformLabel": "Platform",
    "bookingPlatformLabel": "Booking Platform",
    "selectPlatformPlaceholder": "Select your platform",
    "usernameEmail": "Username / Email",
    "usernamePlaceholder": "you@studio.com",
    "password": "Contraseña",
    "passwordPlaceholder": "••••••••",
    "updateCredentials": "Update credentials",
    "twoFaModalTitle": "Configure Eversports 2FA",
    "twoFaMethod": "Method",
    "twoFaTotp": "TOTP (Authenticator app)",
    "twoFaEmail": "Email code",
    "twoFaSms": "SMS code",
    "twoFaSecretLabel": "Secret / code",
    "twoFaContactLabel": "Phone or email",
    "twoFaSecretPlaceholder": "Paste TOTP secret or code",
    "twoFaContactPlaceholder": "Phone number or email",
    "twoFaCodeLabel": "Clave de autenticación",
    "twoFaCodePlaceholder": "Pega la clave secreta TOTP del autenticador",
    "twoFaCodeHint": "Encuentra esta clave en la configuración de tu aplicación de autenticación (p. ej. Google Authenticator, Authy). El código se generará automáticamente.",
    "save": "Guardar",
    "toastStartFlowFailed": "Could not start connection flow.",
    "toastReconnectStarted": "Reconnect flow started.",
    "toastReconnectFailed": "Reconnect failed.",
    "toastDisconnected": "Disconnected.",
    "toastDisconnectFailed": "Disconnect failed.",
    "toastBookingCredentialsUpdated": "Booking platform credentials updated.",
    "toastBookingConnected": "Booking platform connected.",
    "toast2faConfigured": "2FA configured.",
    "errorUserPassRequired": "Username and password are required.",
    "errorSelectPlatform": "Please select a booking platform.",
    "errorInvalidCredentials": "Invalid credentials or platform unavailable. Please retry.",
    "errorGenericRetry": "Something went wrong. Please retry.",
    "error2faSecretRequired": "Secret or code is required.",
    "error2faCodeRequired": "La clave de autenticación es obligatoria para Eversports.",
    "errorUpdateFailed": "Update failed.",
    "errorConnectFailed": "Connect failed.",
    "errorConfigure2faFailed": "Failed to configure 2FA.",
    "errorNoStudioForApi": "No hay ningún estudio disponible para esta cuenta. Añade un estudio antes de gestionar las conexiones.",
    "channelInstagram": "Instagram",
    "channelWhatsapp": "WhatsApp",
    "channelBooking": "Una plataforma para hacer reservas",
    "profile": {
      "viewProfile": "Ver perfil",
      "whatsappTitle": "Conexión de WhatsApp",
      "instagramTitle": "Conexión de Instagram",
      "sectionAssets": "Cuenta y recursos",
      "sectionTemplates": "Plantillas de mensaje",
      "templatesSubtitle": "Las plantillas deben ser aprobadas por Meta antes de usarse fuera de la ventana de 24 horas.",
      "expand": "Expandir panel",
      "collapse": "Contraer panel",
      "refresh": "Actualizar",
      "disconnect": "Desconectar",
      "disconnectTitle": "¿Desconectar el canal?",
      "disconnectBody": "Esto elimina la conexión del canal para este estudio. Puedes volver a conectar más tarde desde Ajustes.",
      "templatesPickerHint": "Las plantillas aprobadas se pueden seleccionar en Chats al responder por WhatsApp.",
      "loading": "Cargando detalles de conexión…",
      "pageName": "Página de Facebook",
      "pageId": "ID de página",
      "emailTitle": "Conexión de correo",
      "providerLabel": "Proveedor",
      "providerGoogle": "Google",
      "providerMicrosoft": "Microsoft",
      "grantHealthWarning": "Tu conexión de correo expiró. Vuelve a conectar para enviar y recibir mensajes.",
      "errorLoadEmail": "No se pudieron cargar los detalles de la conexión de correo."
    },
    "whatsapp": {
      "templates": {
        "create": "Crear plantilla de mensaje",
        "editTitle": "Ver y editar plantilla",
        "editSubtitleEditable": "Actualiza la categoría o el cuerpo del mensaje y guarda. Meta revisará la plantilla automáticamente.",
        "editSubtitleReadOnly": "Esta plantilla está pendiente o aprobada y no se puede editar aquí.",
        "saveChanges": "Guardar cambios",
        "saveSuccess": "Plantilla guardada y enviada a Meta para revisión",
        "saveFailed": "No se pudieron guardar los cambios de la plantilla",
        "nameLocked": "El nombre de la plantilla no se puede cambiar después de crearla",
        "submit": "Enviar para aprobación",
        "testSend": "Envío de prueba",
        "preview": "Vista previa",
        "reviewPresets": "Plantillas OktoGo recomendadas",
        "testSendDialogTitle": "Enviar mensaje de prueba",
        "testSendSuccess": "Mensaje de prueba en cola",
        "testSendFailed": "Error en el envío de prueba",
        "createSuccess": "Plantilla enviada a Meta",
        "createFailed": "No se pudo crear la plantilla",
        "submitFailed": "No se pudo enviar la plantilla para aprobación",
        "emptyProfile": "Sin plantillas de mensaje. Crea una para enviar mensajes fuera de la ventana de 24 horas.",
        "nameHint": "Solo minúsculas, números y guiones bajos",
        "nameInvalid": "El nombre debe ser en minúsculas con letras, números y guiones bajos",
        "bodyRequired": "El cuerpo de la plantilla es obligatorio",
        "bodyLabel": "Cuerpo del mensaje",
        "bodyPlaceholderHint": "Usa {{1}}, {{2}}, … para valores dinámicos. Meta exige un ejemplo por cada variable.",
        "variableSamplesTitle": "Ejemplos de variables para revisión de Meta",
        "variableSamplesHint": "Proporciona ejemplos realistas. Meta rechaza plantillas sin ejemplos (INVALID_FORMAT).",
        "variableSampleLabel": "Ejemplo para {{index}}",
        "variableSamplePlaceholder": "Valor de ejemplo para revisores de Meta",
        "variableSamplesRequired": "Introduce un ejemplo para cada variable del mensaje",
        "variableSampleMetaSlot": "Marcador de posición Meta {{index}}",
        "variables": {
          "customerName": "Nombre del cliente",
          "studioName": "Nombre del estudio",
          "managerName": "Nombre del responsable",
          "className": "Nombre de clase o sesión",
          "classDate": "Fecha de la clase",
          "classTime": "Hora de la clase",
          "followUpNote": "Mensaje de seguimiento",
          "visitDatetime": "Fecha y hora de la visita",
          "bookingDate": "Fecha de reserva",
          "bookingTime": "Hora de reserva",
          "newDate": "Nueva fecha",
          "newTime": "Nueva hora",
          "spotDate": "Fecha del cupo",
          "spotTime": "Hora del cupo",
          "handoffNote": "Mensaje de traspaso",
          "reengagementNote": "Mensaje de reactivación",
          "rebookOffer": "Oferta de nueva reserva",
          "membershipType": "Tipo de membresía",
          "renewalDate": "Fecha de renovación",
          "propertyName": "Nombre de la propiedad",
          "checkinDate": "Fecha de check-in",
          "accessDetails": "Detalles de acceso"
        },
        "testSendTo": "Para (número E.164)",
        "e164Invalid": "Introduce un número E.164 válido (p. ej. +34612345678)",
        "variableLabel": "Variable {{index}}",
        "delete": "Eliminar plantilla",
        "deleteConfirmTitle": "¿Eliminar plantilla de mensaje?",
        "deleteConfirmBody": "¿Eliminar «{{name}}» (estado: {{status}})? Se quitará la plantilla de Meta. Puede que tengas que crearla de nuevo para enviar mensajes fuera de la ventana de 24 horas. Las plantillas bootstrap de OktoGo pueden tener que recrearse.",
        "deleteConfirmAction": "Eliminar plantilla",
        "deleteSuccess": "Plantilla eliminada",
        "deleteFailed": "No se pudo eliminar la plantilla",
        "deleteNotDeletable": "Esta plantilla no se puede eliminar mientras esté pendiente o aprobada",
        "rejectionReason": "Motivo de rechazo: {{reason}}",
        "presetClassReminder": "Recordatorio de clase con detalles de reserva (envío demo T-1)",
        "presetSupportFollowup": "Seguimiento del manager tras escalada IA (T-2)",
        "presetTrialWelcome": "Bienvenida de prueba — demo crear/enviar (T-3)",
        "catalog": {
          "classReminder": "Recordatorio de clase o sesión con fecha, hora y opción de cambio",
          "supportFollowup": "Seguimiento del manager tras escalada del copiloto IA o consulta abierta",
          "trialWelcome": "Confirmación de prueba o primera visita",
          "bookingConfirmed": "Confirmación de reserva tras reserva del estudio o IA",
          "bookingCancelled": "Aviso de cancelación con opción de volver a reservar",
          "bookingRescheduled": "Cambio de fecha u hora de la reserva",
          "waitlistAvailable": "Plaza en lista de espera — invitar al cliente a reservar",
          "aiHandoff": "Copiloto IA escalado — un manager responderá pronto",
          "inactiveReengagement": "Recontacto fuera de la ventana de mensajería de 24 h",
          "classCancelledStudio": "Clase o sesión cancelada por el estudio",
          "membershipRenewal": "Recordatorio de renovación de membresía o paquete",
          "stayCheckin": "Detalles de check-in para alquiler vacacional y ayuda antes de la llegada"
        }
      }
    },
    "instagram": {
      "humanAgentEligible": "Elegible para Human Agent",
      "humanAgentEligibleYes": "Sí",
      "humanAgentEligibleNo": "No"
    },
    "webhookPending": {
      "banner": "Conexión activa, pero la entrega de mensajes está pendiente de verificación",
      "reverify": "Volver a verificar el webhook"
    },
    "whatsappActivate": {
      "banner": "WhatsApp está vinculado pero aún no activado para mensajería. Introduce tu PIN de WhatsApp de 6 dígitos para terminar la configuración.",
      "cta": "Completar activación",
      "title": "Completar activación de WhatsApp",
      "description": "Introduce el PIN de 6 dígitos de la verificación en dos pasos de WhatsApp. No cambies el PIN en WhatsApp Manager antes — completa la activación aquí para que Meta registre el número en Cloud API. OktoGo no guarda este PIN.",
      "pinLabel": "PIN de WhatsApp",
      "pinPlaceholder": "PIN de 6 dígitos",
      "submit": "Activar",
      "cancel": "Cancelar",
      "close": "Cerrar",
      "success": "WhatsApp está activado para mensajería.",
      "errors": {
        "pinInvalid": "El PIN no coincide con la verificación en dos pasos de WhatsApp.",
        "reverificationRequired": "WhatsApp requiere volver a verificar el teléfono en Meta Business.",
        "rateLimited": "Demasiados intentos. Vuelve a intentarlo en hasta 72 horas.",
        "generic": "Error de activación. Inténtalo de nuevo.",
        "network": "Error de red durante la activación."
      }
    },
    "firstTrialReadiness": {
      "title": "Estado de enlaces de primera prueba",
      "precedenceNote": "Edita estos enlaces en Datos del estudio → General. Conexiones solo muestra el estado.",
      "scenario1Ready": "Escenario 1 listo: enlace de registro/prueba configurado",
      "scenario1Missing": "Escenario 1: falta enlace de registro/prueba",
      "scenario2Ready": "Escenario 2 listo: página de Eversports del estudio configurada",
      "scenario2Missing": "Escenario 2: falta la página de Eversports del estudio",
      "ctaStudioData": "Abrir Studio Data",
      "ctaAiSettings": "Abrir AI Settings"
    }
  },
  "archive": {
    "permissionToast": "No tienes permiso para ver el archivo.",
    "restoreError": "No se pudo restaurar",
    "studioLimitReached": "Máximo 5 estudios activos. Archiva uno antes de restaurar este estudio.",
    "conversationRestored": "Conversación restaurada",
    "studioRestored": "Estudio restaurado",
    "deleteError": "No se pudo eliminar",
    "deleteBlockedFeedback": "Esta conversación tiene feedback de IA y no se puede eliminar permanentemente. Permanece archivada.",
    "conversationDeleted": "Conversación eliminada permanentemente",
    "studioDeleted": "Estudio eliminado permanentemente",
    "loadError": "No se pudo cargar el archivo.",
    "empty": "Aún no hay elementos archivados",
    "noFilterResults": "Sin resultados con los filtros actuales.",
    "columnName": "Nombre",
    "columnType": "Tipo",
    "columnStudio": "Estudio",
    "columnArchived": "Archivado",
    "columnActions": "Acciones",
    "channelTitle": "Canal",
    "channelWhatsapp": "WhatsApp",
    "channelInstagram": "Instagram",
    "channelUnknown": "—",
    "restore": "Restaurar",
    "deleteForever": "Eliminar para siempre",
    "purgeTitle": "Eliminar para siempre",
    "purgeBodyConversation": "¿Eliminar permanentemente esta conversación archivada ({{name}})? No se puede deshacer.",
    "purgeBodyStudio": "¿Eliminar permanentemente este estudio archivado ({{name}})? No se puede deshacer.",
    "purgeDangerConversation": "Se eliminarán de la base de datos todos los mensajes y metadatos de esta conversación.",
    "purgeDangerStudio": "El estudio y sus datos relacionados se eliminarán permanentemente de la base de datos.",
    "loadMore": "Cargar más",
    "purgeConversationTitle": "¿Eliminar la conversación para siempre?",
    "purgeConversationBody": "Elimina el chat archivado de forma permanente. No se puede deshacer.",
    "purgeStudioTitle": "¿Eliminar el estudio para siempre?",
    "purgeStudioBody": "Escribe el nombre del estudio para confirmar la eliminación permanente.",
    "searchAria": "Buscar en el archivo por nombre",
    "filter": {
      "panelTitle": "Filtro",
      "panelDescription": "Filtra chats y estudios archivados por tipo, estudio y cuándo se archivaron.",
      "filterArchiveAria": "Filtrar archivo",
      "sectionType": "Tipo",
      "sectionStudio": "Estudio",
      "sectionArchivedAgo": "Archivado hace",
      "typeAll": "Todos",
      "typeChat": "Chat",
      "typeStudio": "Estudio",
      "allStudios": "Todos los estudios",
      "filterByStudioAria": "Filtrar por estudio",
      "tagTypeChat": "Tipo: chat",
      "tagTypeStudio": "Tipo: estudio",
      "tagStudio": "Estudio: {{name}}",
      "tagArchived": "Archivado: {{label}}",
      "studioFallback": "Estudio"
    },
    "time": {
      "all": "Todas las fechas",
      "today": "Hoy",
      "yesterday": "Ayer",
      "this_week": "Esta semana",
      "last_week": "La semana pasada",
      "this_month": "Este mes",
      "last_month": "El mes pasado",
      "this_year": "Este año"
    },
    "rowType": {
      "conversation": "Chat",
      "studio": "Estudio"
    }
  },
  "studio": {
    "scopeAllStudiosRejected": "«Todos los estudios» no está disponible para tu cuenta. Se seleccionó un solo estudio.",
    "scopeSwitchFailed": "No se pudo actualizar el contexto del estudio. Inténtalo de nuevo."
  },
  "vertical": {
    "fitness": {
      "dataSectionNavLabel": "Datos del estudio",
      "dataSectionPageTitle": "Datos del estudio",
      "dataSectionReadOnlyNoun": "Datos del estudio",
      "dataSectionAddUnitExpandedLabel": "Añadir estudio",
      "dataSectionListColumnTitle": "Estudios",
      "dataSectionMobileDescription": "Gestiona la información del estudio, FAQ, políticas y horarios de clases.",
      "aggregateScopeLabel": "Todos los estudios",
      "selectScopeActionLabel": "Seleccionar estudio",
      "overlaySelectScopeMessage": "Cambia a un estudio concreto para editar la configuración.",
      "teamInviteUnitsMulti": "Estudios (uno o más)",
      "teamInviteUnitsSingle": "Estudio",
      "teamInviteNoUnitsAvailable": "No hay estudios disponibles para invitaciones en tu cuenta.",
      "teamInviteSelectAtLeastOne": "Selecciona al menos un estudio.",
      "chatsConversationUnitLabel": "Estudio",
      "chatsIdentificationMatchingCopy": "Estamos vinculando este contacto con un miembro del estudio. Puede tardar un momento.",
      "agentTraceSelectScopeMessage": "Selecciona un estudio para cargar trazas.",
      "agentTraceLoadErrorNeedsScope": "Selecciona un estudio e introduce un UUID de ejecución del agente válido.",
      "agentTraceNoAuditEventsForUnit": "No hay eventos de auditoría para este estudio en este intervalo.",
      "aiSettingsContactOwnerReadOnly": "Contacta al propietario del estudio para cambiar la configuración de IA.",
      "onboardingBookingConnectTitle": "Conectar plataforma de reservas",
      "onboardingBookingConnectSubtitle": "Conecta tu plataforma para sincronizar clases, horarios y membresías.",
      "onboardingBookingUsernamePlaceholder": "tu@estudio.com",
      "dashboardStatConversationsToday": "Conversaciones hoy",
      "dashboardStatHandledByAiPct": "Gestionadas por IA %",
      "dashboardStatBookingsMade": "Reservas realizadas",
      "dashboardStatAvgFirstResponse": "Primera respuesta media",
      "chatsMockJoinedBookingLine": "Unido a Eversports",
      "chatsMockMembershipHeading": "Membresía",
      "chatsMockScheduleHeading": "Clases",
      "chatsCustomerPanelPlatformsHeading": "Plataformas",
      "chatsCustomerPanelAggregatorLabel": "Agregador",
      "chatsCustomerPanelNetworkLabel": "Red",
      "chatsCustomerPanelPrimaryPlatformIdLabel": "ID de cliente Eversports",
      "chatsCustomerPanelSecondaryPlatformIdLabel": "ID de miembro myClubs",
      "chatsCustomerPanelAggregatorIdLabel": "ID del agregador",
      "chatsCustomerPanelCustomerRecordIdLabel": "ID de cliente",
      "chatsCustomerPanelConversationRefLabel": "Conversación",
      "chatsUnmatchedNotFoundTitle": "Cliente no encontrado en Eversports",
      "chatsUnmatchedNotFoundBody": "Este contacto no coincide con ningún miembro conocido. Puede requerirse búsqueda manual.",
      "chatsIdentificationInProgressTitle": "Identificación de cliente en curso",
      "chatsNoMembershipRecordTitle": "Sin registro de membresía",
      "chatsNoMembershipRecordBody": "Parece una consulta general o un posible nuevo miembro.",
      "visionAgentTraceButtonLabel": "Trazas del agente Vision",
      "pageScopeDescription": "El panel, los chats y los datos del estudio siguen el estudio que elijas aquí. Usa «Todos los estudios» para una vista agregada cuando esté disponible.",
      "connectionsTableUnitColumn": "Estudio",
      "settingsAccountVerticalTitle": "Vertical de producto",
      "settingsAccountVerticalHint": "Fitness mantiene terminología de estudio y clases. Alquiler vacacional cambia textos y canales de anuncios al contexto de propiedad."
    },
    "str": {
      "dataSectionNavLabel": "Datos de la propiedad",
      "dataSectionPageTitle": "Datos de la propiedad",
      "dataSectionReadOnlyNoun": "Datos de la propiedad",
      "dataSectionAddUnitExpandedLabel": "Añadir propiedad",
      "dataSectionListColumnTitle": "Propiedades",
      "dataSectionMobileDescription": "Gestiona la información de la propiedad, FAQ, políticas y detalles para huéspedes.",
      "aggregateScopeLabel": "Todas las propiedades",
      "selectScopeActionLabel": "Seleccionar propiedad",
      "overlaySelectScopeMessage": "Cambia a una propiedad concreta para editar la configuración.",
      "teamInviteUnitsMulti": "Propiedades (una o más)",
      "teamInviteUnitsSingle": "Propiedad",
      "teamInviteNoUnitsAvailable": "No hay propiedades disponibles para invitaciones en tu cuenta.",
      "teamInviteSelectAtLeastOne": "Selecciona al menos una propiedad.",
      "chatsConversationUnitLabel": "Propiedad",
      "chatsIdentificationMatchingCopy": "Estamos vinculando este contacto con un huésped o una reserva. Puede tardar un momento.",
      "agentTraceSelectScopeMessage": "Selecciona una propiedad para cargar trazas.",
      "agentTraceLoadErrorNeedsScope": "Selecciona una propiedad e introduce un UUID de ejecución del agente válido.",
      "agentTraceNoAuditEventsForUnit": "No hay eventos de auditoría para esta propiedad en este intervalo.",
      "aiSettingsContactOwnerReadOnly": "Contacta al propietario de la propiedad para cambiar la configuración de IA.",
      "onboardingBookingConnectTitle": "Conectar canal de anuncios",
      "onboardingBookingConnectSubtitle": "Conecta tu plataforma de anuncios o reservas para sincronizar disponibilidad, reservas y datos de huéspedes.",
      "onboardingBookingUsernamePlaceholder": "tu@ejemplo.com",
      "dashboardStatConversationsToday": "Conversaciones hoy",
      "dashboardStatHandledByAiPct": "Gestionadas por IA %",
      "dashboardStatBookingsMade": "Reservas confirmadas",
      "dashboardStatAvgFirstResponse": "Primera respuesta media",
      "chatsMockJoinedBookingLine": "Canal de reserva principal",
      "chatsMockMembershipHeading": "Programa para huéspedes",
      "chatsMockScheduleHeading": "Próximas estancias",
      "chatsCustomerPanelPlatformsHeading": "Canales",
      "chatsCustomerPanelAggregatorLabel": "Canal principal",
      "chatsCustomerPanelNetworkLabel": "Partner",
      "chatsCustomerPanelPrimaryPlatformIdLabel": "ID de huésped",
      "chatsCustomerPanelSecondaryPlatformIdLabel": "Ref. de reserva",
      "chatsCustomerPanelAggregatorIdLabel": "Ref. de origen",
      "chatsCustomerPanelCustomerRecordIdLabel": "ID de registro de huésped",
      "chatsCustomerPanelConversationRefLabel": "Conversación",
      "chatsUnmatchedNotFoundTitle": "Huésped no encontrado en el sistema de reservas",
      "chatsUnmatchedNotFoundBody": "Este contacto no coincide con un huésped o reserva conocida. Puede requerirse búsqueda manual.",
      "chatsIdentificationInProgressTitle": "Identificación de huésped en curso",
      "chatsNoMembershipRecordTitle": "Sin reserva registrada",
      "chatsNoMembershipRecordBody": "Parece una consulta general o una posible nueva reserva.",
      "visionAgentTraceButtonLabel": "Trazas del agente Vision",
      "pageScopeDescription": "El panel, los chats y los datos de la propiedad siguen la propiedad que elijas aquí. Usa «Todas las propiedades» para una vista agregada cuando esté disponible.",
      "connectionsTableUnitColumn": "Propiedad",
      "settingsAccountVerticalTitle": "Vertical de producto",
      "settingsAccountVerticalHint": "Alquiler vacacional usa terminología de propiedad y huésped con canales de anuncios. Fitness usa estudio y clases."
    }
  },
  "notFound": {
    "code": "404",
    "title": "¡Vaya! Página no encontrada",
    "home": "Volver al inicio"
  },
  "setupNotComplete": {
    "title": "Configuración del estudio incompleta",
    "body": "El propietario del estudio aún no ha terminado la configuración. Tendrás acceso cuando esté completa."
  },
  "routeErrorBoundary": {
    "summary": "No se pudo cargar esta página. Inténtalo recargando la página.",
    "reload": "Recargar página"
  },
  "ai": {
    "readOnlyContactOwner": "Contacta al propietario del estudio para cambiar la configuración de IA.",
    "readOnlyContactOwnerStr": "Contacta al propietario de la propiedad para cambiar la configuración de IA.",
    "sectionReplies": "Respuestas por tema",
    "regimeLockedBanner": "Durante el piloto, el envío automático permanece desactivado en todos los temas. Contacta a OktoGo para desbloquear el interruptor Auto/Manual.",
    "toastRegimeLocked": "El envío automático está bloqueado para este estudio piloto. Contacta a OktoGo para desbloquearlo.",
    "sectionTone": "Tono de conversación",
    "sectionLearn": "Aprender de las respuestas del equipo",
    "sectionAttribution": "Etiquetas de respuestas automáticas de IA",
    "sectionEscalation": "Reglas de escalado",
    "sectionEscalationHint": "Cuándo marcar una conversación para tu revisión (escalado soft). La IA sigue redactando un borrador — tú lo apruebas o lo editas antes de enviarlo. La toma de control — cuando el cliente pide un humano, o la IA no puede terminar con seguridad — es un cinturón de seguridad aparte y no se controla con estas reglas.",
    "sectionSessionNudge": "Recordatorios de ventana de mensajería",
    "sectionSessionNudgeHint": "Mensaje breve opcional al cliente antes del cierre de la ventana de texto libre de WhatsApp. Solo se ejecuta si la automatización del servidor está activa; un borrador de IA pendiente omite el envío.",
    "escalationStillDraftsNote": "Tanto si las marcan estas reglas como un traspaso de seguridad, las conversaciones escaladas esperan tu aprobación — excepto los mensajes de confirmación de identidad, que se envían siempre para que el cliente pueda empezar. La IA sigue redactando respuestas sugeridas para que nunca empieces desde cero.",
    "save": "Guardar",
    "saving": "Guardando…",
    "saved": "Configuración de IA guardada.",
    "saveError": "No se pudo guardar la configuración de IA.",
    "loadError": "No se pudo cargar la configuración de IA.",
    "bookingRequiredTitle": "Conecta primero una plataforma de reservas",
    "bookingRequiredBody": "Activar el manejo automático para temas de reservas funciona mejor cuando hay una plataforma conectada en Ajustes → Canales.",
    "confirmEnableBooking": "¿Activar sin plataforma de reservas conectada?",
    "enable": "Activar",
    "useCase": {
      "booking": "Nueva reserva",
      "rebook": "Cambio de reserva",
      "cancel": "Cancelación",
      "info": "Información general",
      "schedule": "Consulta de horarios",
      "trial": "Prueba / primera visita",
      "account": "Cuenta / membresía",
      "campaignLead": "Lead de campaña"
    },
    "firstTrial": {
      "helper": {
        "title": "Prueba / primera visita — Copilot elige el camino por ti:",
        "scenario1": "Sin cuenta en la plataforma de reservas → enlace de registro / prueba",
        "scenario2": "Con cuenta de Eversports, nuevo en tu estudio → página de Eversports del estudio; las reservas siguen en borrador hasta que esté vinculado en tu estudio",
        "scenario2Booking": "Tras la vinculación aplican las reglas normales de reserva (fila «Nueva reserva»)"
      },
      "readiness": {
        "title": "Estado de enlaces de primera prueba",
        "precedenceNote": "Edita estos enlaces en Datos del estudio → General. Conexiones solo muestra el estado.",
        "scenario1Ready": "Escenario 1 listo: enlace de registro/prueba configurado",
        "scenario1Missing": "Escenario 1: falta enlace de registro/prueba",
        "scenario2Ready": "Escenario 2 listo: página de Eversports del estudio configurada",
        "scenario2Missing": "Escenario 2: falta la página de Eversports del estudio",
        "ctaStudioData": "Abrir Studio Data",
        "ctaConnections": "Abrir Connections"
      }
    },
    "tone": {
      "friendly": {
        "label": "Cercano",
        "desc": "Cálido, cercano, con emojis. Empieza en tú. Pasa a usted si el cliente o el equipo escribe claramente usted."
      },
      "professional": {
        "label": "Formal",
        "desc": "Formal, sin emojis. Empieza con usted. Pasa a tú si el cliente o el equipo escribe luego claramente tú."
      },
      "casual": {
        "label": "Informal",
        "desc": "Relajado y breve. Empieza en tú. Pasa a usted si el cliente o el equipo escribe claramente usted."
      }
    },
    "repliesByTopicDesc": "Auto: tras las comprobaciones y la confirmación del cliente cuando se requiera (p. ej. rebooking), la IA puede ejecutar la acción y enviar una confirmación verificada. Manual: tras esas mismas comprobaciones y la confirmación del cliente, la IA espera tu aprobación antes de cualquier cambio en la plataforma y antes de la confirmación.",
    "repliesByTopicManualWait": "En Manual, estos temas esperan tu aprobación.",
    "repliesByTopicStillSentChip": "Se envían igual solos: confirmar quién es, ya está en la clase, un «ya está» más tarde, un «ya estás verificado» más tarde, y un «¿cancelo?» antes de que confirmes. Nada más.",
    "approveAllFirst": "Aprobar primero todos los mensajes",
    "autoSendAllMessages": "Enviar automáticamente todos los mensajes",
    "bookingUseCaseHint": "Conecta una integración en Ajustes → Canales para usar datos de agenda y reservas en vivo.",
    "toneSectionDesc": "Estilo inicial de cada conversación. El chat puede volverse más formal o más informal si el cliente o el equipo usa luego un usted o un tú claro.",
    "learnSectionDesc": "La IA copia cómo escribe el equipo: longitud, calor, despedida. Un usted o tú claro del equipo basta para la siguiente sugerencia. Gana el último usted/tú claro del cliente o del equipo. Sin ejemplo claro, sigue el estilo inicial de arriba.",
    "attributionSectionDesc": "Las respuestas automáticas de IA siempre se muestran con este nombre de asistente en los chats. No se pueden desactivar las etiquetas. WhatsApp e Instagram siguen usando tu cuenta business conectada — no este nombre.",
    "attributionDisplayNameLabel": "Nombre visible del asistente",
    "attributionDisplayNameHint": "Escribe solo el nombre — AI se añade automáticamente y no se puede quitar. Ejemplo: Kai → Kai AI. Los clientes de WhatsApp e Instagram siguen viendo tu cuenta business conectada.",
    "attributionDisplayNameErrorEmpty": "Introduce un nombre para el asistente.",
    "attributionDisplayNameErrorToken": "Introduce un nombre para el asistente.",
    "attributionDisplayNameAiSuffixTitle": "AI siempre se añade después del nombre",
    "attributionDisplayNameAiSuffixSr": "AI es fijo después del nombre y no se puede editar.",
    "attributionDisplayNameSave": "Guardar nombre del asistente",
    "attributionDisplayNameReset": "Restablecer predeterminado",
    "attributionBackendPendingHint": "Aún no se puede guardar — el servidor necesita la API del nombre del asistente. Puedes redactar y validar el nombre aquí.",
    "attributionStudio": "Nombre del estudio",
    "attributionAi": "Asistente de IA",
    "attributionLockedHint": "Solo el propietario o el gestor pueden cambiar este ajuste.",
    "toastAttributionSaved": "Nombre visible del asistente guardado.",
    "toastAttributionBackendNotReady": "Aún no se puede guardar — el nombre visible del asistente no está disponible en el servidor.",
    "escalateAfterPrefix": "Escalar tras",
    "escalateAfterSuffix": "intentos fallidos antes de marcar la conversación para tu revisión.",
    "dialogEnableAutoSendTitle": "Activar envío automático",
    "dialogEnableAutoSendBody": "Tras las comprobaciones necesarias y la confirmación del cliente cuando el flujo lo requiera (p. ej. rebooking = cancelar + reservar), la IA puede ejecutar esta acción y enviar una confirmación verificada sin tu aprobación. En modo manual espera tu aprobación antes de cualquier cambio en la plataforma y antes de la confirmación. ¿Continuar?",
    "dialogAutoSendAllTitle": "Enviar automáticamente todos los mensajes",
    "dialogAutoSendAllBody": "Para reservas, cambios y cancelaciones, la IA solo actúa tras las comprobaciones necesarias y la confirmación del cliente cuando el flujo lo requiera (rebooking = una confirmación para cancelar + reservar juntos). En modo manual espera tu aprobación antes de cualquier cambio en la plataforma y antes de la confirmación.",
    "enableAll": "Activar todo",
    "toastSettingSaveError": "No se pudo guardar ese ajuste.",
    "toastAttributionError": "No se pudieron actualizar las etiquetas de respuestas automáticas.",
    "toastEscalationError": "No se pudieron actualizar las reglas de escalado.",
    "sessionNudgeEnabled": "Activar recordatorio automático de sesión",
    "sessionNudgeWhatsapp": "WhatsApp",
    "sessionNudgeInstagram": "Instagram (experimental)",
    "sessionNudgeOnlyEscalated": "Solo si está escalado",
    "sessionNudgeMaxOne": "Como máximo un recordatorio por escalación",
    "sessionNudgeWhenRemaining": "Enviar cuando el tiempo restante sea como máximo",
    "sessionNudgeHours4": "4 horas",
    "sessionNudgeHours6": "6 horas",
    "sessionNudgeHours8": "8 horas",
    "sessionNudgePreview": "Vista previa del mensaje predeterminado",
    "sessionNudgePreviewMayDiffer": "El mensaje real puede sonar más o menos formal según la conversación, dependiendo de cómo tu equipo le escribe a ese cliente.",
    "toastSessionNudgeError": "No se pudieron guardar los ajustes del recordatorio de sesión.",
    "toastAutoHandleError": "No se pudo actualizar el manejo automático.",
    "toastAutoHandleRateLimited": "Demasiadas actualizaciones a la vez. Vuelve a intentarlo en un momento.",
    "toastAutoHandleRateLimitedWithRetry": "Demasiadas actualizaciones a la vez. Inténtalo de nuevo en unos {{seconds}} segundos.",
    "toastToneError": "No se pudo actualizar el tono.",
    "toastGenericUpdateError": "No se pudo actualizar la configuración.",
    "connectBookingFirst": "Conecta primero una plataforma de reservas en Ajustes → Canales.",
    "connectListingFirst": "Conecta primero un canal de anuncios en Ajustes → Canales.",
    "campaignLeadNotReady": "Configura primero una campaña lista en Datos del estudio → Campañas antes de activarlo.",
    "campaignLead": {
      "hintNoCampaign": "Aún no hay campañas configuradas",
      "hintNotReady": "La campaña aún no está lista",
      "hintEndDateMissing": "A la campaña le falta una fecha de fin",
      "hintEndingSoon": "La campaña termina el {{date}}",
      "hintExpired": "La última campaña ha expirado",
      "hintSummaryActive": "{{count}} activas",
      "hintSummaryScheduled": "{{count}} programadas",
      "hintSummaryNotReady": "{{count}} no listas",
      "hintSummaryExpired": "{{count}} expiradas",
      "ctaOpenCampaigns": "Abrir Campañas"
    },
    "groupBooking": {
      "sectionTitle": "Reservas de grupo",
      "sectionDesc": "Copilot detecta solicitudes de grupo y corporativas en la conversación y las gestiona con seguridad en lugar de reservar plazas individuales.",
      "tabsAriaLabel": "Secciones de los ajustes de reservas de grupo",
      "tabBasics": "General",
      "tabPolicies": "Políticas",
      "lockAria": "Solo propietario",
      "enableLabel": "Activar reservas de grupo para este estudio",
      "enableHint": "Cuando está activo, las conversaciones tipo grupo reciben un borrador pendiente y una checklist para el manager en lugar de un envío automático.",
      "fulfillmentLabel": "¿Cómo gestionar las reservas de grupo?",
      "fulfillment": {
        "manual": "Manual",
        "semiAutomated": "Semiautomático",
        "fullyAutomated": "Totalmente automático",
        "manualDesc": "Copilot redacta borradores y muestra una checklist del roster; tú reservas manualmente en el manager de la plataforma.",
        "semiAutomatedDesc": "Copilot redacta borradores; tras tu aprobación puede ejecutar pasos seguros del roster en el manager de la plataforma cuando esté listo.",
        "fullyAutomatedDesc": "Solo piloto. Copilot puede ejecutar pasos seguros antes de la aprobación; tú supervisas y puedes intervenir en cualquier momento.",
        "requiresConnection": "Semiautomático y Totalmente automático requieren una plataforma de reservas conectada. Conecta una en Ajustes → Canales."
      },
      "maxPartyLabel": "Mayor grupo que Copilot puede automatizar",
      "maxPartyHint": "Solo aplica a Semiautomático y Totalmente automático. Los grupos más grandes siguen siendo manuales. Rango 2–50.",
      "escalationTargetLabel": "Avisar para la atención",
      "escalationTargetHint": "Quién recibe alerta cuando una reserva de grupo necesita una persona. Entrega: Chats mientras estás en Copilot; notificación móvil cuando estás fuera (según Cuenta → Notificaciones).",
      "escalationTarget": {
        "owner": "Propietario del estudio",
        "allChatMembers": "Todos los managers con acceso a chats"
      },
      "saveButton": "Guardar política de reservas de grupo",
      "toastSaved": "Política de reservas de grupo guardada.",
      "toastSaveError": "No se pudo guardar la política de reservas de grupo.",
      "toastEndpointUnavailable": "La API de política de reservas de grupo aún no está disponible en este servidor. Los ajustes se aplicarán cuando el administrador despliegue la actualización del backend.",
      "toastLoadUnavailable": "No se pudieron cargar los ajustes de IA desde el servidor.",
      "endpointUnavailableHint": "Guardar está desactivado hasta que el endpoint de la política esté disponible."
    },
    "escalation": {
      "no_match": "Ninguna intención reconocida",
      "sentiment": "Sentimiento negativo detectado",
      "repeat": "El cliente repite la solicitud 3 o más veces",
      "explicit": "El cliente pide hablar con una persona"
    }
  },
  "channelConnect": {
    "header": {
      "connectInstagram": "Conectar Instagram",
      "connectWhatsapp": "Conectar WhatsApp",
      "selectStudioTooltip": "Selecciona un solo estudio para conectar canales"
    },
    "wizard": {
      "yes": "Sí",
      "no": "No",
      "continue": "Continuar",
      "back": "Atrás",
      "cancel": "Cancelar",
      "retry": "Reintentar",
      "learnMore": "Más información",
      "instagram": {
        "title": "Conectar Instagram",
        "introBody": "Conecta tu cuenta profesional de Instagram para que Oktogo gestione los mensajes de clientes en Chats.",
        "q1": "¿Ya tienes una cuenta profesional de Instagram (Business o Creator)?",
        "q1Yes": "Sí, tengo una cuenta profesional",
        "q1No": "No, aún no",
        "q1HelpTitle": "Cambiar a cuenta profesional",
        "q1Help": "Abre Instagram → Ajustes → Cuenta → Cambiar a cuenta profesional y elige Business o Creator.",
        "q2": "¿Tu cuenta de Instagram está vinculada a una página de Facebook?",
        "q2Yes": "Sí, está vinculada a una página de Facebook",
        "q2No": "No, aún no está vinculada",
        "q2HelpTitle": "Vincular Instagram a una página de Facebook",
        "q2Help": "En Meta Business Suite o en los ajustes de la página de Facebook, conecta tu cuenta de Instagram a la página de tu estudio.",
        "q3": "¿Está habilitado el acceso a mensajes para esta cuenta de Instagram?",
        "q3Yes": "Sí, el acceso a mensajes está habilitado",
        "q3No": "No, aún no está habilitado",
        "q3HelpTitle": "Habilitar acceso a mensajes",
        "q3Help": "En la app de Instagram: Ajustes → Mensajes → Controles de mensajes → permitir acceso para herramientas conectadas.",
        "confirm": "Conectar Instagram",
        "checkProfessional": "Cuenta profesional de Instagram (Business o Creator)",
        "checkFacebookPage": "Instagram vinculado a una página de Facebook",
        "checkMessageAccess": "Acceso a mensajes habilitado"
      },
      "whatsapp": {
        "title": "Conectar WhatsApp",
        "introBody": "Conecta WhatsApp Business para que Oktogo gestione los mensajes de clientes en Chats.",
        "q1": "¿Tienes una cuenta de WhatsApp Business (o un número apto para la API Business)?",
        "q1Yes": "Sí, tengo WhatsApp Business",
        "q1No": "No, aún no",
        "q1HelpTitle": "Configurar WhatsApp Business",
        "q1Help": "Instala WhatsApp Business en el teléfono del estudio o registra un número con Meta para la API Business.",
        "q2": "¿Puedes iniciar sesión con la cuenta de Meta que administra este negocio?",
        "q2Yes": "Sí, tengo acceso de administrador de Meta",
        "q2No": "No, no tengo acceso de administrador",
        "q2HelpTitle": "Acceso de administrador de Meta",
        "q2Help": "Necesitas acceso de administrador a la cuenta de Meta Business que posee el perfil de WhatsApp Business.",
        "confirm": "Conectar WhatsApp",
        "checkBusiness": "Cuenta de WhatsApp Business lista",
        "checkMetaAccess": "Acceso de administrador de Meta confirmado"
      }
    },
    "oauth": {
      "successInstagram": "Instagram conectado",
      "successInstagramHandle": "Conectado como {{handle}}",
      "successWhatsapp": "WhatsApp conectado",
      "webhookPending": "Instagram está conectado, pero la entrega de mensajes está pendiente de verificación."
    },
    "errors": {
      "accessDenied": "Cancelaste los permisos. Vuelve a intentarlo cuando estés listo.",
      "connectFailed": "Error de conexión. Inténtalo de nuevo."
    },
    "email": {
      "connect": "Conectar correo",
      "connectTooltip": "Conectar un buzón compartido para correos de clientes en Chats (todos los estudios)",
      "wizard": {
        "title": "Conectar correo",
        "introBody": "Conecte el buzón de su estudio para que OktoGo gestione hilos de correo de clientes en Chats.",
        "providerGoogle": "Google (Gmail / Google Workspace)",
        "providerMicrosoft": "Microsoft (Outlook / Microsoft 365)",
        "prereqsTitle": "Antes de conectar",
        "prereqsBody": "Use una cuenta con la que pueda iniciar sesión en Google o Microsoft. Necesita permiso para conectar este buzón para su negocio.",
        "confirm": "Conectar correo",
        "defaultStudioLabel": "Estudio predeterminado para hilos de correo nuevos",
        "defaultStudioHint": "Los correos entrantes nuevos se enrutan a este estudio hasta que el cliente aclare lo contrario.",
        "openChats": "Abrir Chats"
      },
      "oauth": {
        "success": "Correo conectado",
        "successAddress": "Conectado como {{address}}"
      }
    }
  },
  "whatsappSignup": {
    "title": "Conectar WhatsApp Business",
    "description": "Autoriza a OktoGo a gestionar mensajes en nombre de tu cuenta de WhatsApp Business.",
    "connectButton": "Conectar con Meta",
    "fbFlow": "Completa el inicio de sesión en la ventana de Meta…",
    "saving": "Guardando conexión…",
    "successRedirect": "¡WhatsApp conectado! Redirigiendo…",
    "hint": "Iniciarás sesión en Meta y seleccionarás tu cuenta de WhatsApp Business.",
    "metaCompleteHint": "La autorización de Meta está completa. Introduce tu PIN abajo para terminar la conexión en OktoGo.",
    "pinDescription": "Introduce el PIN de 6 dígitos de la verificación en dos pasos de WhatsApp para registrar este número en la API Cloud de Meta.",
    "pinLabel": "PIN de WhatsApp",
    "pinPlaceholder": "PIN de 6 dígitos",
    "pinSubmit": "Activar y conectar",
    "retry": "Reintentar",
    "errors": {
      "generic": "Algo salió mal.",
      "missingConfig": "Falta la configuración de la app Meta. Revisa VITE_META_APP_ID y VITE_META_ES_CONFIG_ID.",
      "phoneAlreadyConnected": "Este número de teléfono ya está conectado a otro estudio de tu cuenta.",
      "metaExchangeFailed": "Meta no pudo intercambiar el código. Verifica la URI de redirección del servidor.",
      "wabaDiscoveryFailed": "No se encontró la cuenta de WhatsApp Business. Asegúrate de tener un WABA con número.",
      "studioContextRequired": "Selecciona un estudio concreto antes de conectar WhatsApp y vuelve a intentarlo desde Ajustes o Chats.",
      "connectFailed": "No se pudo guardar la conexión de WhatsApp. Inténtalo de nuevo.",
      "sessionExpired": "Tu sesión ha caducado. Inicia sesión de nuevo y vuelve a conectar WhatsApp desde Ajustes.",
      "network": "Error de red al guardar. Inténtalo de nuevo.",
      "cancelled": "Inicio de sesión en Meta cancelado. Inténtalo de nuevo.",
      "sdkLoadFailed": "No se pudo cargar el SDK de Meta. Actualiza la página.",
      "activationRequired": "Introduce tu PIN de WhatsApp de 6 dígitos para activar la mensajería.",
      "pinInvalid": "El PIN no coincide con la verificación en dos pasos de WhatsApp.",
      "reverificationRequired": "WhatsApp requiere volver a verificar el teléfono en Meta Business.",
      "registerRateLimited": "Demasiados intentos de registro. Vuelve a intentarlo en hasta 72 horas.",
      "registerFailed": "Error al registrar el número de WhatsApp. Inténtalo de nuevo."
    }
  },
  "whatsappTemplates": {
    "title": "Plantillas de mensajes",
    "subtitle": "Plantillas aprobadas de tu cuenta de WhatsApp Business conectada (fuera de la ventana de 24 h).",
    "loading": "Cargando plantillas…",
    "empty": "No hay plantillas de mensaje para esta cuenta.",
    "errorLoad": "No se pudieron cargar las plantillas de mensaje.",
    "retry": "Reintentar",
    "colName": "Nombre",
    "colLanguage": "Idioma",
    "colCategory": "Categoría",
    "colStatus": "Estado"
  },
  "whatsappSetup": {
    "title": "Cuenta de WhatsApp conectada",
    "subtitle": "Detalles en vivo de tu cuenta de WhatsApp Business (WABA), teléfono, verificación y suscripción webhook.",
    "loading": "Cargando detalles de la cuenta…",
    "errorLoad": "No se pudieron cargar los detalles de la cuenta de WhatsApp.",
    "retry": "Reintentar",
    "wabaId": "ID WABA",
    "phoneNumber": "Número de teléfono",
    "displayName": "Nombre para mostrar",
    "phoneVerification": "Verificación del teléfono",
    "nameVerification": "Verificación del nombre para mostrar",
    "webhookSubscription": "Suscripción webhook",
    "webhookSubscribed": "Suscrito",
    "webhookNotSubscribed": "No suscrito",
    "webhookAppId": "ID de app Meta",
    "webhookFields": "Campos suscritos"
  },
  "onboarding": {
    "shell": {
      "stepOf": "Paso {{current}} de {{total}}",
      "exitAria": "Salir de la configuración",
      "exitTitle": "¿Guardar el progreso y continuar más tarde?",
      "exitDescription": "Se guardará tu progreso. Podrás reanudar la configuración la próxima vez que inicies sesión.",
      "cancel": "Cancelar",
      "saveAndExit": "Guardar y salir"
    },
    "instagram": {
      "title": "Conectar Instagram",
      "description": "Conecta tu cuenta de Instagram Business para que OktoGo gestione los mensajes de los clientes.",
      "errorConnect": "Error al conectar Instagram. Inténtalo de nuevo.",
      "connected": "Conectado",
      "connectButton": "Conectar Instagram",
      "retry": "Reintentar",
      "continue": "Continuar",
      "skipLater": "Lo haré más tarde",
      "testErrorEnable": "(Test: activar modo error)",
      "testErrorDisable": "(Test: desactivar modo error)"
    },
    "whatsapp": {
      "title": "Conectar WhatsApp Business",
      "description": "Conecta tu cuenta de WhatsApp Business para que OktoGo gestione los mensajes de los clientes.",
      "errorConnect": "Error al conectar WhatsApp. Inténtalo de nuevo.",
      "connected": "Conectado",
      "connectButton": "Conectar WhatsApp",
      "retry": "Reintentar",
      "continue": "Continuar",
      "skipLater": "Lo haré más tarde",
      "back": "Atrás"
    },
    "booking": {
      "title": "Conectar plataforma de reservas",
      "description": "Conecta tu plataforma para sincronizar clases, horarios y membresías.",
      "errorCredentials": "Credenciales no válidas o plataforma no disponible. Inténtalo de nuevo.",
      "connected": "Conectado",
      "continue": "Continuar",
      "platformLabel": "Plataforma de reservas",
      "usernameLabel": "Usuario / Correo",
      "passwordLabel": "Contraseña",
      "skipLater": "Lo haré más tarde",
      "disclosure": "Almacenamos tus credenciales de forma segura para sincronizar reservas y horarios. Tu contraseña está cifrada y solo es accesible para los servidores seguros de OktoGo.",
      "testConnection": "Probar conexión",
      "back": "Atrás",
      "testErrorEnable": "(Test: activar modo error)",
      "testErrorDisable": "(Test: desactivar modo error)",
      "manualCodeLabel": "Código de acceso adicional",
      "manualCodeHint": "Eversports envió un código de un solo uso (SMS, correo o app de autenticación). Introdúcelo y vuelve a probar.",
      "manualCodeRequiredTitle": "Se requiere verificación manual"
    },
    "twoFa": {
      "title": "Configurar credenciales 2FA",
      "description": "Eversports requiere 2FA. Proporciona tus credenciales para que OktoGo se autentique en tu nombre.",
      "errorVerify": "Error en la verificación 2FA: revisa tus credenciales e inténtalo de nuevo.",
      "verified": "2FA verificada",
      "verifiedHint": "Autenticación con Eversports lista",
      "continue": "Continuar",
      "methodLabel": "Método 2FA",
      "methodAuthenticator": "App de autenticación",
      "methodSms": "SMS",
      "methodBackup": "Código de respaldo",
      "secretLabel": "Secreto 2FA / código de respaldo",
      "disclosure": "Tus credenciales 2FA están cifradas y se guardan solo para que OktoGo se autentique con Eversports en tu nombre. No se comparten.",
      "skipLater": "Lo haré más tarde",
      "back": "Atrás",
      "testButton": "Probar 2FA",
      "syncLimitedHint": "La sincronización puede ser limitada hasta que proporciones 2FA",
      "testErrorEnable": "(Test: activar modo error)",
      "testErrorDisable": "(Test: desactivar modo error)"
    },
    "email": {
      "title": "Conectar correo",
      "description": "Conecta el buzón de tu estudio para que OktoGo gestione los hilos de correo de clientes en Chats.",
      "connectButton": "Conectar correo",
      "skipLater": "Lo haré más tarde",
      "back": "Atrás",
      "continue": "Continuar",
      "connected": "Correo conectado",
      "connectedHint": "Tu buzón está listo para correo de clientes en Chats.",
      "optionalHint": "Opcional — puedes conectar el correo más tarde en Ajustes."
    },
    "messaging": {
      "title": "Conectar canales de mensajería",
      "description": "Conecta Instagram y WhatsApp para que OktoGo gestione los mensajes de clientes en Chats.",
      "continue": "Continuar",
      "skipLater": "Lo haré más tarde",
      "back": "Atrás",
      "optionalHint": "Opcional — puedes conectarlos más tarde en Ajustes → Canales."
    },
    "oauthCallbackLoading": "Conectando tu cuenta…",
    "errors": {
      "connectFailed": "Error de conexión. Inténtalo de nuevo."
    },
    "sync": {
      "titleRunning": "Sincronizando los datos de tu estudio…",
      "titleDone": "¡Sincronización completada!",
      "titleSkipped": "Por ahora ya está todo listo",
      "hintRunning": "Solo tardará un momento.",
      "hintDone": "Los datos de tu estudio se importaron correctamente.",
      "hintSkipped": "Aún no hay plataforma de reservas conectada. Puedes conectarla más tarde desde Ajustes → Conexiones.",
      "stageClasses": "Obteniendo clases",
      "stageSchedule": "Sincronizando horario",
      "stageMemberships": "Importando membresías",
      "stagePolicies": "Cargando políticas",
      "continueDashboard": "Ir al panel",
      "completing": "Completando…",
      "summaryDemo": "{{classes}} clases, {{sessions}} próximas sesiones, {{tiers}} niveles de membresía importados.",
      "summaryReal": "{{classes}} clases y {{policies}} políticas importadas correctamente.",
      "summaryGeneric": "Datos del estudio importados correctamente.",
      "summaryNoData": "Configuración completada. Puedes conectar una plataforma de reservas más tarde desde Ajustes → Conexiones.",
      "confirmTitle": "Confirma tus enlaces públicos de Eversports",
      "confirmLinks": "Revisa las URL de Overview, Classes y Prices en Studio Data → General.",
      "confirmClassPrices": "Las descripciones de clases y Pricing options se sincronizan desde Eversports cuando están disponibles — revísalas en Studio Data → Clases.",
      "confirmHonesty": "Los precios en vivo de Eversports tienen prioridad. Hasta que haya precios por clase, Copilot puede enviar el enlace de la página Prices — nunca inventamos importes en euros.",
      "ctaReviewLinks": "Revisar enlaces de sección en Studio Data",
      "ctaReviewClasses": "Revisar clases y precios en Studio Data",
      "titleError": "Error de sincronización",
      "hintError": "No pudimos importar los datos de tu estudio en este momento.",
      "errorBody": "Ocurrió un problema al importar tus datos. Puedes reintentar ahora o terminar la configuración e intentarlo de nuevo más tarde desde Ajustes.",
      "retry": "Reintentar sincronización",
      "back": "Atrás"
    }
  },
  "management": {
    "title": "Gestión piloto",
    "subtitle": "Invita y controla el onboarding de clientes piloto.",
    "signOut": "Cerrar sesión",
    "login": {
      "title": "Acceso de management",
      "subtitle": "Inicia sesión con una cuenta admin de plataforma.",
      "emailLabel": "Correo",
      "emailPlaceholder": "admin@oktogo.ai",
      "passwordLabel": "Contraseña",
      "passwordPlaceholder": "Introduce la contraseña",
      "signIn": "Iniciar sesión",
      "signingIn": "Iniciando sesión..."
    },
    "accept": {
      "title": "Aceptar invitación piloto",
      "subtitle": "Crea una contraseña segura para iniciar el onboarding.",
      "email": "Correo",
      "studio": "Estudio",
      "expiresAt": "Expira el",
      "password": "Contraseña",
      "passwordPlaceholder": "Crea una contraseña",
      "terms": "Acepto los términos del onboarding piloto",
      "submit": "Aceptar invitación",
      "accepting": "Aceptando invitación..."
    },
    "createInvite": {
      "title": "Crear invitación piloto",
      "email": "Correo del propietario",
      "fullName": "Nombre completo (opcional)",
      "studioName": "Nombre del estudio",
      "planId": "ID del plan",
      "submit": "Crear y enviar invitación",
      "creating": "Creando invitación..."
    },
    "invites": {
      "title": "Invitaciones piloto",
      "loading": "Cargando invitaciones...",
      "empty": "No hay invitaciones para el filtro seleccionado.",
      "filterAria": "Filtrar invitaciones por estado",
      "filterAll": "Todos los estados",
      "columns": {
        "email": "Correo",
        "studio": "Estudio",
        "status": "Estado",
        "expiresAt": "Expira el",
        "actions": "Acciones"
      },
      "actions": {
        "resend": "Reenviar",
        "revoke": "Revocar"
      }
    },
    "status": {
      "pending": "Pendiente",
      "sent": "Enviada",
      "accepted": "Aceptada",
      "expired": "Expirada",
      "revoked": "Revocada"
    },
    "vertical": {
      "fitness": "Fitness",
      "shortTermRental": "Alquiler de corta estancia"
    },
    "messages": {
      "inviteCreated": "Invitación piloto creada ({{id}}).",
      "inviteActionSuccess": "Invitación actualizada.",
      "inviteAccepted": "Invitación aceptada. Tu cuenta ya está activa."
    },
    "errors": {
      "login": "No se pudo iniciar sesión.",
      "platformAdminRequired": "Se requiere acceso de admin de plataforma.",
      "loadInvites": "No se pudieron cargar las invitaciones.",
      "createInvite": "No se pudo crear la invitación.",
      "inviteAction": "No se pudo actualizar la invitación.",
      "invalidInviteToken": "Falta el token de invitación.",
      "loadInviteToken": "No se pudo validar este token de invitación.",
      "acceptInvite": "No se pudo aceptar la invitación."
    }
  },
  "compliance": {
    "aiDisclosure": {
      "auto": {
        "plain": "¡Hola! Aquí responde el asistente de IA de este estudio. Puedo ayudar con horarios, reservas y preguntas rápidas - un miembro del equipo puede intervenir en cualquier momento.",
        "named": "¡Hola {{channelFirstName}}! Aquí responde el asistente de IA de este estudio. Puedo ayudar con horarios, reservas y preguntas rápidas - un miembro del equipo puede intervenir en cualquier momento."
      },
      "manual": {
        "plain": "¡Hola! Aquí responde el asistente de IA de este estudio. He preparado esta respuesta y un miembro del equipo la ha revisado antes de enviarla - una persona del equipo puede atender en cualquier momento.",
        "named": "¡Hola {{channelFirstName}}! Aquí responde el asistente de IA de este estudio. He preparado esta respuesta y un miembro del equipo la ha revisado antes de enviarla - una persona del equipo puede atender en cualquier momento."
      }
    }
  }
}
